import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    //debug: true,
    fallbackLng: "de",
    resources: {
      en: {
        translation: {
          //COMPONENTS
          AddComparisonButton: {
            config: "config. ",
            savedToast:
              'Configuration has been saved under "My Configurations".',
            addToComparison: "Add product to 'My Configutations'?",
            comparisonInfo:
              "The 'My Configutations' item in the sidebar allows you to cache configurations and compare data. To better find this configuration again, you can now optionally save a name and further notes.",
            saveConfiguration: "Save for comparison",
            cancelButton: "Cancel",
            customNameLabel: "Name of configuration",
            customNamePlaceholder: "Name of configuration",
            customNameRequired: "One input is required",
            customNotesLabel: "Other configuration notes",
            saveConfig: "Save configuration",
          },
          Spinner: {
            loadProduct:
              "Please be patient. Your individual product is being created just for you.",
            loadPreview: "Loading preview.",
          },
          NotRightProductDiv: {
            question: "Not the right product for you? No problem.",
            question2:
              "In addition to our series-production range, we also offer individual special solutions.",
            support: "We are always ready to support you.",
            support2: "Please contact us",
            support3: "Or use our contact form for an individual offer.",
            offer:
              "For you was not yet the right thing? We will be happy to work out an individual offer for you.",
          },
          GoBackModal: {
            //in BackButton and Nav
            preventGoingBackTitle: "Go to home page?",
            preventGoingBackText:
              "You will lose the progress of your previous configuration.",
            preventGoingBackConfirmButton: "Continue",
            cancelButton: "Cancel",
          },
          FormatSelector: {
            downloadPDF: "Download PDF datasheet",
            PDFThumbnailAlt:
              "Example PDF Datasheet with Table and Model Preview",
            multiselectLabel: "Other formats",
            multiselectPlaceholder: "Select formats",
            multiselectPlaceholderText: "Search formats",
            multiselectSelectAllText: "Select All",
            multiselectDeselectAllText: "Deselect All",
            download: "Download",
            loading: "Loading...",
          },
          KeyButton: {
            copy: "Copy",
            message: "Product key copied to clipboard",
            title: "Input product key",
            confirmButton: "Continue",
            cancelButton: "Cancel",
          },
          MainNavigation: {
            portalName: "Hydraulic cylinder",
            configurator: "Configurator",
            myProjects: "My configurations",
          },
          Nav: {
            portalName: "Hydraulic cylinder",
          },
          SendButton: {
            requestOffer: "Request offer now",
            requestOfferDemo: "Share link now",
            requestOfferShort: "Request offer",
            requestOfferShortDemo: "Share link",
            tooShort: "Too short!",
            validEmail: "Must be a valid email!",
            offerModalTitle: "Request offer",
            offerModalTitleDemo: "Share link by enter an email address",
            offerModalConfirm: "Send",
            offerModalCancel: "Cancel",
            general: "General",
            firstNameLabel: "First name",
            firstNamePlaceholder: "Enter first name",
            lastNameLabel: "Last name",
            lastNamePlaceholder: "Enter last name",
            companyLabel: "Company name",
            companyPlaceholder: "Enter company name",
            emailLabel: "Email",
            emailPlaceholder: "Enter email",
            phoneLabel: "Phone number",
            phonePlaceholder: "Enter phone number",
            usageLabel: "Application/Industry (optional)",
            usagePlaceholder: "Add information on how to use the product",
            usageInfo: "possible device name",
            delivery: "Delivery",
            enterQuantity: "Enter quantity",
            firstDelivery: "Required quantity of first delivery",
            quantitySeries: "Required batch size in series",
            quantityAnnual: "Required annual quantity",
            deliveryTimeLabel: "Desired delivery time",
            deliveryTimePlaceholder: "Select desired delivery time",
            annotation: "Annotation",
            annotationLabel: "Annotation (optional)",
            annotationPlaceholder: "Add additional information",
            consentSavingContactData: "Saving contact data in local storage",
            consentSavingContactDataDesc:
              "When activated, we store the contact data entered in the form in the local storage. Future forms will then be automatically pre-filled with this data.",
            error: "Error:",
            privacySettings: "Privacy settings",
            required: "Please complete all required fields.",
            zipLabel: "ZIP",
            zipPlaceholder: "Enter zip code",
            cityLabel: "City",
            cityPlaceholder: "Enter city name",
            streetLabel: "Street",
            streetPlaceholder: "Enter street name",
            countryLabel: "Country",
            countryPlaceholder: "Select country",
            contactQuestion: "Have you already been in contact with Liebherr?",
            myLiebherrLogin:
              "Login with MyLiebherr to automatically pre-fill this form with your contact data.",
            myLiebherrLogout:
              "Logout with MyLiebherr. This will reset the contact data with the previous stored data.",
          },
          Sidebar: {
            myConfigs: "My configurations",
            profile: "Profile",
            contact: "Contact",
          },
          Sticky: {
            myConfigs: "My configutations",
            contact: "Contact",
          },
          EditProfileButton: {
            editModalConfirm: "Save",
            editModalCancel: "Cancel",
          },
          Dropdown: {
            reset: "Reset filter",
          },
          //PAGES
          contact: {
            desc: "Contact us! We are happy to answer your questions regarding our components and provide you with an individual offer.",
            link: "Contact us at Liebherr-Components",
            heinz: "Michael Heinz",
            contact: "Our colleagues are at your disposal",
            website: "www.liebherr.com",
            websiteContact: "Contact us at Liebherr-Components",
            url: "https://www.liebherr.com/en/deu/products/components/hydraulics/hydraulic-cylinders/hydraulic-cylinders.html",
            contactUrl:
              "https://www.liebherr.com/en/deu/specials/components-contact-form/contact-form.html",
          },
          compare: {
            compareTitle: "Product comparison",
            noNotes: "no notes",
            open: "open",
            errorMessage: "Could not find selected item in items",
          },
          configurator: {
            partKeyError: "Product key could not be assigned",
            start: "Start",
            configuration: "Configuration",
            summary: "Summary",
            affordanceToInput: "Enter now",
            next: "Next",
          },
          downloads: {
            downlaods: "Downloads",
          },
          finder: {
            finderTitle: "Calculation assistant",
            finderDesc:
              "By entering technical details, such as the system pressure, we will suggest a suitable product within our series ranges. \n Then continue the configuration based on the features you have already selected. \n Please note the different options within the selected series within our suggestion.",
            results: "Results",
            range: "Range",
            rangeTo: "to",
            series260: "260 bar series-production range",
            series380: "380 bar series-production range",
            seriesISO6022: "Series-production range according to ISO 6022",
            start: "Start",
            suggestionTitle: "Our suggestion for you:",
            matchTitle: "Which series fits you?",
            scopeTitle: "Your options",
            scopeDescribtion:
              "The following options are available in this series:",
            describtionSeries260:
              "Welded hydraulic cylinder with various mounting types for mobile and stationary applications up to 260 bar",
            describtionSeries380:
              "Durable hydraulic cylinder for dynamic applications up to 380 bar",
            describtionSeriesISO6022:
              "Bolted standard cylinder with many equipment options up to 250 bar",
            series260Option1: "Venting",
            series260Option2: "Rod end",
            series380Option1: "End-position cushioning",
            series380Option2: "Special painting",
            series380Option3: "Seawater resistance",
            seriesISO6022Option1: "End-position cushioning",
            seriesISO6022Option2: "Proximity switch",
            seriesISO6022Option3: "Distance measuring system",
            seriesISO6022Option4: "Venting",
            empty: "No matching results found. Try adjusting the values.",
            pressure: "Pressure",
          },
          myconfigs: {
            myconfigsTitle: "My configurations",
            goToMyconfigs: "Open 'My configurations'",
            goToComparison: "For comparison",
            compare: "Compare",
            preview: "Preview",
            id: "Identification",
            actions: "Actions",
            details: "Details",
            open: "Open",
            remove: "Remove",
            data: "Data",
            nothingSaved: "No saved configurations available.",
            comparisonInfo:
              "Select up to three configurations in the table underneath to compare with",
          },
          profile: {
            profileTitle: "My Profildata",
            edit: "Edit",
            list: '[{"label": "Name", "value": "John Doe"}, {"label": "E-Mail", "value": "test@test.test"}, {"label": "Company", "value": "Test Company"}, {"label": "Street", "value": ""}, {"label": "Zip Code, City", "value": ""}, {"label": "Country", "value": ""}]',
          },
          loginTitle: "Liebherr Login",
          loginText: "You are not logged in.",
          registerText: "You do not have an account yet?",
          registerLink: "Register now.",
          loggedinText: "Logged in as",
          logOut: "Log out",
          footerLinks:
            '[{"label": "Imprint, data protection and legal information", "itemId": "imprint"},{"label": "Privacy Settings", "itemId": "cmp", "to": "javascript:usercentrics.showSettings();", "target": "_self"}]',
          start: {
            selectSeries: "Select series",
            series260: "260 bar series-production range",
            series380: "380 bar series-production range",
            seriesISO6022: "Series-production range according to ISO 6022",
            series260content: "For mobile and stationary applications",
            series380content: "For mobile applications",
            seriesISO6022content: "For stationary applications",
            start: "Start",
            whichSeries: `You do not know which series fits you?
              We tell you!`,
            toAssistant: "To the calculation assistant",
            haveKey: "Do you already have a product key?",
            keyInfo:
              "In each configuration step, we update the product key for you. By entering the product key, you can reload your configuration at a later time.",
            enterKey: "Enter product key",
            loadConfig: "Load configuration",
          },
          summary: {
            partKeyError: "Product key could not be assigned",
            pistonRod: "Piston / rod diameter",
            length: "Installation length / Stroke",
            myConfig: "My configuration",
            download: "Download formats",
            more: "More Data",
            sae: "SAE port",
            paint: "Paint",
            rcol: "RAL number:",
          },
          confirm: {
            title: "Thank you. Your request has been successfully sent.",
          },
          imprint: {
            title: "Imprint, data protection and legal information",
            termsAndConditions: {
              title: "Legal Notice",
              describtion:
                "By using the configurator, you acknowledge that you are solely responsible for ensuring that the configured product complies with the rights of third parties and the applicable legal requirements and that it is suitable for the use intended by you, insofar as this depends on the selected configuration. The configuration serves only as a general information, is not binding and does not constitute an offer for sale. You may receive a concrete offer as well as further details after sending an enquiry with the configuration key. Errors excepted. The delivery of the configured product is subject to our TERMS OF DELIVERY AND PAYMENT",
              link: "General Terms and Conditions of Delivery and Payment of Liebherr-Components GmbH",
            },
            imprint: {
              title: "Imprint",
              addressTitle: "Address:",
              address: `Liebherr-Components Kirchdorf GmbH \n St. Vitus 5 \n 88457 Kirchdorf an der Iller \n Germany`,
              telTitle: "Tel.:",
              tel: "+497354 80 - 8448",
              emailTitle: "Email",
              email: "info.cok@liebherr.com",
              emailDataProtection: "datenschutz.cok@liebherr.com",
              emailDataProtection2: "datenschutz@liebherr.com",
              managementTitle: "Management:",
              management: "Ulrich Hammerle \n Thomas Sonntag",
              vatTitle: "VAT No.:",
              vat: "DE 289151259",
              companiesRegisterTitle: "Companies Register:",
              companiesRegister: "District Court Ulm, HRB 729181",
              contactTitle: "Contact",
              companyName: "Liebherr-Components Kirchdorf GmbH",
              contactAdress: `St. Vitus 5 \n 88457 Kirchdorf an der Iller \n Germany`,
              contactAdressDataProtection: `Liebherr-IT Services GmbH \n  St. Vitus 5 \n 88457 Kirchdorf an der Iller \n Germany`,
            },
            dataProtection: {
              title: "Data Protection Declaration",
              subTitle: "Online Sales Configurator",
              intro:
                "We, Liebherr-Components Kirchdorf Deutschland GmbH, are pleased that you are visiting our web pages (hereinafter also referred to collectively as “website”) and that you have thereby expressed an interest in the Liebherr Group. \n \n We attach great importance to the protection and security of your personal data. Therefore, we consider it vital to inform you in the following about which of your personal data we process for what purpose and what rights you have in respect of your personal data.",
              generalInfo: {
                title: "A.	General Information",
                first: {
                  title: "What is personal data and what does processing mean?",
                  dashOne:
                    "<strong>“Personal data”</strong> (hereinafter also referred to as “data”) are all the details that make a statement about a natural person. Personal data are not just details that allow a direct conclusion to be drawn about a certain person (such as the name or e-mail address of a person), but also information with which with suitable additional knowledge a connection can be made with a certain person.",
                  dashTwo:
                    "<strong>“Processing”</strong> means any action taken with your personal data (such as collection, recording, organisation, structuring, storage, use or erasure of data).",
                },
                second: {
                  title:
                    "Who is the controller for the processing of your data?",
                  describtion:
                    "The controller for the processing of your data is:",
                },
                third: {
                  title: "How can you reach our data protection officer?",
                  subTitle: "Corporate Privacy",
                  describtion:
                    "Our data protection officer can be reached at the following contact details:",
                },
                fourth: {
                  title: "What rights do you have as a data subject?",
                  sectionOne: {
                    describtion:
                      "As a data subject, you have the right, within the legal scope, to:",
                    dashOne: "Information about your data;",
                    dashTwo:
                      "Rectification of inaccurate data and completion of incomplete data;",
                    dashThree:
                      "Erasure of your data, particularly if (1) they are no longer necessary for the purposes stated in this Data Protection Declaration, (2) you have withdrawn your consent and there is no other legal ground for the processing, (3) your data have been unlawfully processed, or (4) you have objected to the processing and there are no overriding legitimate grounds for the processing;",
                    dashFour:
                      "Restriction of the processing of your data, particularly if the accuracy of the data is contested by you or the processing of your data is unlawful and instead of deletion you demand restriction of use;",
                    dashFive:
                      "Object to processing of your data based on legitimate interests, on grounds relating to your particular situation, or, without specific justification, to processing of your data carried out for direct marketing purposes; unless it is an objection to direct marketing, we ask that you explain the reasons why we should not process your data as we may do, when you lodge an objection. In the event of your reasoned objection, we will examine the merits of the case and cease processing unless we can demonstrate compelling legitimate grounds for the processing which override your interests, rights and freedoms or for the establishment, exercise or defence of legal claims;",
                    dashSix:
                      "Receive your data in a structured, commonly used and machine-readable format and to have your data transmitted from us directly to another controller;",
                    dashSeven:
                      "Withdraw consent, if you have given us consent for processing. Please note that the lawfulness of processing based on consent before its withdrawal will not be affected by your withdrawal.",
                  },
                  sectionTwo: {
                    describtion: `If you assert any of the above-stated rights, please understand that we may require you to provide evidence showing that you are the person you claim to be.
                    \n Furthermore, you have the right to lodge a complaint with a supervisory authority if you consider that the processing of your data infringes the GDPR.`,
                  },
                },
                fifth: {
                  title: "Links to other websites",
                  describtion:
                    "Our website may contain links to and from websites of other providers not affiliated with us (“third parties”). After clicking on the link, we no longer have any influence on the processing of any data transmitted to the third party when the link is clicked (such as the IP address or the URL on which the link is located), as the behaviour of third parties is naturally beyond our control. Therefore, we cannot assume any responsibility for the processing of such data by third parties.",
                },
              },
              dataProcessing: {
                title: "Data processing",
                first: {
                  title: "Log files",
                  describtion:
                    "Each time you access and use our website, the web browser used on your terminal equipment (computer, smartphone or similar) automatically sends information to our web servers, which we store in so-called log files.",
                  sectionOne: {
                    title: "What data do we process and for what purposes?",
                    describtion: "We process the following data:",
                    dashOne: "Your (external) IP address",
                    dashTwo: "Date and time of access",
                    dashThree: "Domain name of your internet access provider",
                    dashFour:
                      "The type and version of browser you are using and the operating system you are using",
                    dashFive:
                      "URL (address on the internet) of the web page you were on at the time of the access",
                    dashSix:
                      "The files you retrieve via the respective web page (type of access, name of the retrieved file, URL of the retrieved file, success of the retrieval)",
                    dashSeven:
                      "The amount of data transmitted to you when visiting the respective web page",
                    dashEight:
                      "If applicable, date and time of submission when using web forms",
                  },
                  sectionTwo: {
                    describtionOne:
                      "These data are in principle processed by us solely for the purpose of ensuring stability as well as network and information security.",
                    describtionTwo:
                      "Processing for other purposes may only be considered if the necessary legal requirements pursuant to Article 6 para. 4 GDPR are met. In that case, we will of course comply with any information obligations pursuant to Article 13 para. 3 GDPR and Article 14 para. 4 GDPR.",
                  },
                  sectionThree: {
                    title: "On what legal basis do we process your data?",
                    describtionOne:
                      "The processing of your data is carried out for purposes of legitimate interests pursuant to Article 6 para. 1 point f GDPR.",
                    describtionTwo:
                      "Our legitimate interests pursued are the improvement and maintenance of the stability or functionality and the security of our website.",
                    describtionThree:
                      "You have the right to object, on grounds relating to your particular situation, at any time to processing based on Article 6 para. 1 point f GDPR.",
                  },
                },
                second: {
                  title: "Authentication/Authorisation",
                  describtion:
                    "Authentication on our website takes place using an existing Liebherr account at Liebherr-IT Services GmbH, St. Vitus 5, 88457 Kirchdorf an der Iller, Germany.",
                  sectionOne: {
                    title: "What data do we process and for what purposes?",
                    describtionOne: "We process the following data:",
                    dashOne:
                      "User Principal Name (UPN) \n <strong>Note:</strong> This data is transmitted to us by Liebherr-IT Services GmbH when you authenticate with a Liebherr account.",
                    describtionTwo:
                      "These data are in principle processed by us solely for the purpose of authentication on our website or central authentication in the context of the use of non-publicly available content.",
                    describtionThree:
                      "Processing for other purposes may only be considered if the necessary legal requirements pursuant to Article 6 para. 4 GDPR are met. In that case, we will of course comply with any information obligations pursuant to Article 13 para. 3 GDPR and Article 14 para. 4 GDPR.",
                  },
                  sectionTwo: {
                    title: "On what legal basis do we process your data?",
                    describtion:
                      "The processing of your data is carried out for the performance of a contract or in order to take steps prior to entering into a contract pursuant to Article 6 para. 1 point b GDPR.",
                  },
                },
                third: {
                  title: "Contact form",
                  describtion:
                    "On our website, we offer you the opportunity to send inquiries to us or to other companies via web forms. If you take advantage of this option, we will transmit your data collected via the respective form by e-mail to the addressee selected by you. If we ourselves are the addressee of your inquiry, we will also process your data in order to process your message or inquiry and to contact you.",
                  sectionOne: {
                    title: "What data do we process and for what purposes?",
                    describtion: "We process the following data:",
                    dashOne: "First and last name (when quotation is prepared)",
                    dashTwo: "Company name (when quotation is prepared)",
                    dashThree: "Address (when quotation is prepared)",
                    dashFour: "E-mail address (when submitting an offer)",
                    dashFive: "Telephone number (when submitting an offer)",
                    dashSix: "Delivery address (when quotation is prepared)",
                  },
                  sectionTwo: {
                    describtionOne:
                      "These data are in principle processed by us solely for the following purposes",
                    dashOne:
                      "Service provision (transmission of your message or inquiry to the addressee)",
                    dashTwo:
                      "Your data will be transmitted to the responsible seller or dealer for the purpose of preparing an offer and contacting you. These sellers or dealers are authorized to process this data exclusively within the framework specified by us and have been obligated by us to delete this data after fulfillment of the service contract or purpose fulfillment.",
                    dashThree:
                      "Answering and further processing of your message or inquiry, if we ourselves are the addressee of your message or inquiry.",
                    describtionTwo:
                      "Processing for other purposes may only be considered if the necessary legal requirements pursuant to Article 6 para. 4 GDPR are met. In that case, we will of course comply with any information obligations pursuant to Article 13 para. 3 GDPR and Article 14 para. 4 GDPR.",
                  },
                  sectionThree: {
                    title: "On what legal basis do we process your data?",
                    describtion:
                      "The processing of your data is based on the following legal ground(s):",
                    dashOne:
                      "Fulfillment of a contract or implementation of pre-contractual measures (Article 6 para. 1 point a GDPR)]",
                    dashTwo:
                      "Compliance with a legal obligation (Article 6 para. 1 point c GDPR)",
                  },
                },
                fourth: {
                  title: "Use of cookies and other technologies",
                  sectionOne: {
                    title: "A. General",
                    describtion:
                      "In providing our website, we use cookies and other technologies. In the following cookie notices we provide you – as a user of our website – with additional information on data processing via the use of cookies and other technologies.",
                  },
                  sectionTwo: {
                    title: "I. What are cookies and other technologies?",
                    describtionOne:
                      "<strong>Cookies</strong> are small text files that a web server can store and read on your terminal equipment (computer, smartphone or similar) by means of the web browser that you use. Cookies contain individual, alphanumeric character strings that enable identification of the web browser that you are using and may also contain information on user-specific settings.",
                    describtionTwo:
                      "In addition to cookies, we use other technologies as follows:",
                    dashOne:
                      "Using so-called <strong>“local storage technology”</strong>, data is only stored locally, i.e. solely on your terminal equipment and not on the web server, in the so-called “local storage” of your web browser. In contrast to cookies, data stored using local storage technology does not possess an expiry date and is not automatically deleted without further action; you can, however, delete this data yourself via your web browser. Please refer to the instructions of your web browser manufacturer on how to delete data stored using local storage technology.",
                    dashTwo:
                      "In addition, we have integrated so-called <strong>“tracking pixels”</strong> (also called “pixels”, “pixel tags” or “web beacons”) on our website. Tracking pixels are small, usually invisible, image files that are automatically loaded by a web server and can provide information about your web browser or terminal equipment as well as your use of our website. This information can in turn be used to create a profile that is recognised when you visit our website again.",
                    describtionThree:
                      "The aforementioned cookies and other technologies are hereinafter collectively referred to as “cookies”.",
                  },
                  sectionThree: {
                    title:
                      "II. What types of cookies and other technologies exist?",
                    describtionOne:
                      "We distinguish between essential cookies on the one hand and optional cookies on the other:",
                    dashOne:
                      "<strong>Essential cookies</strong> are those that are technically necessary for the functionality as well as for ensuring the security and stability of our website and information technology systems. We also assign to this category those cookies that store certain settings that you have made, options selected or information entered until you close your web browser (at the latest), in order to provide the desired function that you have requested (e.g. login status, language setting etc.). Your consent is not required to store or read essential cookies. You cannot, therefore, manage essential cookies via the <a>settings</a> of the consent management service that we use, but only via your web browser and delete cookies stored there or block storage of cookies.",
                    dashTwo:
                      "<strong>Optional Cookies</strong> are those that are not essential for functionality nor to ensure the security and stability of our website and information technology systems, but are used for analysis or marketing purposes. These cookies can, for example, be used to compile anonymous statistics and collect information on how you use our website, which enables us to analyse the use of our website and thereby optimise it. We also assign to this category those cookies that store certain settings that you have made, options selected or information entered; these remain after you have closed your web browser in order to provide the desired function that you have requested (e.g. login status by selecting “Remember my e-mail address”, wish list, compare list etc.) over a longer term. To store or read optional cookies, your prior consent is generally required. You can consent to the use of optional cookies and withdraw any consent that you have granted at any time with future effect via the <a>settings</a> of the consent management service that we use.",
                    describtionTwo:
                      "Both essential and optional cookies may be so-called “session cookies” or “persistent cookies”, which differ in their intended lifetime or functional life:",
                    dashThree:
                      "<strong>Session cookies</strong> are stored on your terminal equipment and are automatically deleted when you close your web browser.",
                    dashFour:
                      "<strong>Persistent cookies</strong> (or permanent cookies) are stored on your terminal equipment and are not automatically deleted when you close your web browser, but remain on your terminal equipment for a predefined period of time.",
                    dashFive:
                      "Data stored using <strong>local storage technology</strong> does not have an expiry date and therefore has unlimited functional life.",
                    describtionThree:
                      "<strong>Note:</strong> You can generally delete cookies and data stored using local storage technology yourself via your web browser. For details, please refer to the instructions of your web browser manufacturer.",
                  },
                  sectionFour: {
                    title: "B. Use of cookies on our website",
                  },
                  sectionFive: {
                    title: "I. Essential Cookies",
                    subtitle:
                      "1. Which essential cookies are used for what purpose and for how long?",
                    table: {
                      columnOne: "Service",
                      columnTwo: "Purpose",
                      columnThree: "Service provider",
                      columnFour: "Functional life",
                      rowOne: {
                        1: "Consent management",
                        2: "Obtaining and managing consent and storing information about consent decisions",
                        3: `Usercentrics GmbH, \n
                              Sendlinger Straße 7, \n
                              80331 München, Germany`,
                        4: "unlimited",
                      },
                      rowTwo: {
                        1: "Content Delivery Network",
                        2: "Security and stability",
                        3: `Cloudflare, Inc., \n
                              101 Townsend St, \n
                              San Francisco, CA 94107, USA`,
                        4: "30 days",
                      },
                      rowThree: {
                        1: "Load Balancer",
                        2: "Security and stability",
                        3: "-",
                        4: "8 hours",
                      },
                      rowFour: {
                        1: "Language detection",
                        2: "Language detection for user-specific language display of the website",
                        3: "-",
                        4: "Until your web browser is closed",
                      },
                    },
                    dashOne: `<strong>Consent management</strong> <br><br>
                      <a>Open settings</a> <br>
                      In order for you to manage the use of optional cookies on our website, we have implemented a consent management service. Via the consent management service, the first time you access our website, you will be presented with a previously defined query (“Cookies, other technologies and miscellaneous services”), which allows you to accept or decline the use of optional cookies by clicking the appropriate button. In addition, clicking on “settings” will take you to the <a>settings</a> of the consent management service, where you will find inter alia a simplified cookie list, classified by type. With the consent management service, you can inter alia find out about the purposes of the cookies that we use, the data processed in each case as well as any data recipients and, in the case of optional cookies, you can give or withdraw your consent at any time by selecting or deselecting the relevant box. \n\n
                      Please note that essential cookies are already stored upon accessing our website and that the relevant box is preselected. It is not possible to deselect essential cookies via the consent management service. The functionality of the consent management service itself requires the use of certain cookies.
                    `,
                    addressTitle0ne: "Service provider information:",
                    addressOne:
                      "Usercentrics GmbH, Sendlinger Straße 7, 80331 München, Germany",
                    linkTitleOne: "Website:",
                    linkOne: "https://usercentrics.com/",
                    linkTitleTwo: "General Terms and Conditions:",
                    linkTwo: "https://usercentrics.com/terms-and-conditions/",
                    linkTitleThree: "Privacy Policy:",
                    linkThree: "https://usercentrics.com/privacy-policy/",
                    dashTwo: `<strong>Content Delivery Network</strong>  <br>
                      To optimise the loading times of our website, we use a so-called “Content Delivery Network” (hereinafter “CDN”). A CDN is a network of geographically distributed servers connected via the Internet that can be used to deliver web content faster and more securely. Within the CDN, personal data is transferred to various countries; transfer to countries outside the EU or the EEA, so-called “third countries” takes place in compliance with the conditions laid down in Chapter V of the GDPR. With the service provider, standard contractual clauses adopted by the EU Commission (Article 46 para. 2 point c GDPR) have been concluded.
                    `,
                    addressTitleTwo: "Service provider information:",
                    addressTwo:
                      "Cloudflare, Inc., 101 Townsend St, San Francisco, CA 94107, USA",
                    addressTitleThree: "Representative in the European Union:",
                    addressThree:
                      "Cloudflare Portugal, Unipessoal Lda., Largo Rafael Bordalo Pinheiro 29, 1200-369 Lisboa, Portugal",
                    linkTitleFour: "Website:",
                    linkFour: "https://www.cloudflare.com",
                    linkTitleFive: "Privacy Policy:",
                    linkFive: "https://www.cloudflare.com/privacypolicy/",
                    linkTitleSix: "Standard Contractual Clauses:",
                    linkSix:
                      "https://www.cloudflare.com/cloudflare-customer-scc/",
                    dashThree: `<strong>Load Balancer</strong>  <br>
                      For load distribution we use a so-called “load balancer”. With a load balancer, web requests are sent to a load balancing server, which in turn redirects the web request to an internal server. To avoid being routed back and forth between different servers within a session and to ensure uniform processing, your web requests are forwarded to the same server. To identify that server and to ensure correct redirection, we use a cookie with a lifetime or functional life of eight hours.
                    `,
                    dashFour: `<strong>Language detection</strong>  <br>
                      We use a session cookie to enable user-specific language display of our website. In so doing, the language of your web browser will be detected and our website displayed for you in the same language.
                    `,
                  },
                  sectionSix: {
                    title:
                      "2. On which legal basis are essential cookies used?",
                    describtionOne:
                      "In order to be able to demonstrate that – or whether – you have consented to the use of optional cookies requiring your consent, we store the information about your consent, whether given or not, in order to fulfil our legal obligation to provide evidence in accordance with Article 6 para. 1 point c and Article 6 para. 3 point a GDPR in conjunction with Article 7 para. 1 GDPR.",
                    describtionTwo:
                      "Furthermore, we use essential cookies for the purposes of legitimate interests in accordance with Article 6 para. 1 point f GDPR.",
                    describtionThree: "Our legitimate interests pursued are:",
                    dashOne:
                      "Ensuring the security and stability of our website and information technology systems, for example by protecting against attacks in the form of targeted server overloads (Denial of Service attacks) or by using optimal load distribution on servers",
                    dashTwo:
                      "Establishment, exercise or defence of legal claims",
                    dashThree:
                      "Providing and guaranteeing the proper functionalities of our website",
                  },
                  sectionSeven: {
                    title:
                      "3. How can I object to the use of essential cookies?",
                    describtionOne:
                      "You can exercise your right to object by means of the blocking options described below under “Deletion/Blocking of Cookies” (cf. Article 21 para. 5 GDPR), i.e. by blocking essential cookies via your web browser settings.",
                    describtionTwo:
                      "Please note that if you delete without blocking, essential cookies will be used once again when you access our website at a later date. Please also note that deactivating or deleting or blocking essential cookies may affect the performance and functionality of our website and may cause certain features and functions to be unavailable.",
                  },
                  sectionEight: {
                    title: "II. Optional cookies",
                    describtion:
                      "Using the following information, we would like to enable you to make a well-founded decision for or against the use of <strong>optional cookies</strong> and the associated data processing.",
                  },
                  sectionNine: {
                    title:
                      "1. Which optional cookies are used for what purpose and for how long?",
                    table: {
                      columnOne: "Service",
                      columnTwo: "Purpose",
                      columnThree: "Service provider",
                      columnFour: "Functional life",
                      rowOne: {
                        1: "Google Analytics",
                        2: "Web analysis",
                        3: `Google Ireland Limited, \n
                          Gordon House, Barrow Street, \n
                          Dublin 4, Irland
                        `,
                        4: "Up to 2 years",
                      },
                      rowTwo: {
                        1: "Google Ads Conversion Tracking",
                        2: "Marketing",
                        3: `Google Ireland Limited,Gordon House, Barrow Street, Dublin 4, Irland`,
                        4: "Up to 2 years",
                      },
                      rowThree: {
                        1: "Google Ads Remarketing",
                        2: "Marketing",
                        3: `Google Ireland Limited,Gordon House, Barrow Street, Dublin 4, Irland`,
                        4: "Up to 2 years",
                      },
                      rowFour: {
                        1: "Google Ad Manager",
                        2: "Marketing",
                        3: `Google Ireland Limited,Gordon House, Barrow Street, Dublin 4, Irland`,
                        4: "Up to 2 years",
                      },
                      rowFive: {
                        1: "Microsoft Advertising",
                        2: "Marketing",
                        3: `Microsoft Ireland Operations Limited, One Microsoft Place, South County Business Park, Leopardstown, Dublin 18, Irland`,
                        4: "Up to 390 Days",
                      },
                    },
                    dashOne: `<strong>Web analysis</strong>\n
                      Subject to your consent, we use web analysis cookies in order to analyse the use of our website and thereby be able to improve it continuously. The anonymised user statistics obtained (e.g. number and origin of website visitors) enable us to optimise our website and improve its design – such as by placing frequently accessed information or topics on our website at the right location to meet demand. \n
                      Against this background, we use the services detailed hereafter:
                    `,
                    dashTwo: `<strong>Google Analytics</strong>\n
                      For web analysis we use <strong>“Google Analytics”</strong>, a web analysis service of Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland; parent company: Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA (hereinafter collectively “Google”), with the “IP anonymization” extension (also called “IP masking method”). To this end, we have concluded a data processing agreement with Google in accordance with Article 28 GDPR. Google will accordingly process the data collected (data about your terminal equipment or web browser, IP addresses and your website or application activities) on our behalf for the purposes of evaluating your use of our website, compiling reports on website activity and providing other services relating to website and internet usage.\n\n
                      Data collected within the context of Google Analytics may be stored and processed by Google or subprocessors of Google outside the EU or the EEA and thus in a third country, in particular in the USA. The IP masking method that we use ensures that before the IP address is transferred to a Google server in the USA and stored there, it is shortened within EU member states or in other EEA member states so that no IP address is transferred in its entirety, thereby preventing or considerably complicating identification of a person. Only in exceptional cases will the complete, i.e. entire, IP address be transferred to a Google server in the USA and only shortened there.\n\n
                      For a data transfer to a third country, pursuant to the GDPR, additional conditions are to be complied with in order to ensure that the level of data protection guaranteed in the EU is not undermined. In this case, the data transfer to the USA takes place on the basis of the European Commission's adequacy decision of 10 July 2023. According to this adequacy decision, the USA ensures an adequate level of protection within the meaning of Art. 45 GDPR for personal data transferred from the EU to organisations in the USA that are certified under the “EU-U.S. Data Privacy Framework” (hereinafter “DPF”) and included in the “Data Privacy Framework List” (<strong><a>https://www.dataprivacyframework.gov/s/participant-search</a></strong>), maintained and made publicly available by the U.S. Department of Commerce.\n\n
                      Google LLC is certified under the DPF and included in the Data Privacy Framework List.
                    `,
                    addressTitle: "Service provider information:",
                    address:
                      "Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland; Mutterunternehmen: Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA",
                    linkTitleOne: "Google Ads Data Processing Terms:",
                    linkOne:
                      "https://privacy.google.com/businesses/processorterms/",
                    linkTitleTwo: "Terms of Service:",
                    linkTwo:
                      "https://marketingplatform.google.com/about/analytics/terms/us/",
                    linkTitleThree:
                      "Overview of data usage in Google Analytics:",
                    linkThree:
                      "https://support.google.com/analytics/answer/6004245?hl=en",
                    linkTitleFour: "Privacy Policy:",
                    linkFour: "https://policies.google.com/privacy",
                    linkTitleFive:
                      "Technical explanation of “IP Anonymization (or IP masking) in Google Analytics”",
                    linkFive:
                      "https://support.google.com/analytics/answer/2763052?hl=en",
                    describtion: `<strong>Additional note:</strong>
                      If you wish to deactivate Google Analytics across all websites, you can download and install the “Google Analytics Opt-out Browser Add-on” at <strong><a>https://tools.google.com/dlpage/gaoptout?hl=en</a></strong>. This option only disables web analysis as long as you are using a web browser for which you have installed the add-on.
                    `,
                  },
                  sectionTen: {
                    title: "2. On which legal basis are optional cookies used?",
                    describtion:
                      "We use optional cookies on the basis of the consent pursuant to Article 6 para. 1 point a in conjunction with Article 7 GDPR.",
                  },
                  sectionEleven: {
                    title:
                      "3. How can I withdraw the consent that I have given to the use of optional cookies?",
                    linkLabel: "Privacy Settings",
                    link: "javascript:usercentrics.showSettings();",
                    describtionOne:
                      "When you (first) access our website, we request inter alia your consent for the use of optional cookies by means of a predefined query (“Cookies, other technologies and miscellaneous services”). You can withdraw the consent that you have given at any time with effect for the future and thereby prevent further collection of your data by deselecting optional cookies (web analysis, marketing) in the <a>settings</a> of the consent management service.",
                    describtionTwo:
                      "If and insofar as you do not consent or withdraw consent already given (further) data collection by means of optional cookies requiring consent and the associated data processing will cease. This presents no drawbacks when using the website, unless you also deactivate the cookie functions for essential cookies.",
                    describtionThree:
                      "The withdrawal of consent does not affect the lawfulness of processing based on consent before its withdrawal.",
                    describtionFour:
                      "As an alternative to withdrawing your consent, you can also make use of the options described below under “Deletion/Blocking of Cookies” to delete or block cookies using the information provided there.",
                  },
                  sectionTwelve: {
                    title: "C. Deletion/Blocking of Cookies",
                    describtionOne:
                      "Cookies are stored on your terminal equipment, so you have the control over them. If you do not want us to recognise your terminal equipment, you can deactivate or delete cookies already stored on your terminal equipment – manually or automatically – at any time and/or block storage of cookies with future effect by making the appropriate setting in your web browser software, e.g. “do not accept cookies” or similar. Most web browsers can also be configured in such a way that cookie storage is only accepted if you agree to this separately on a case-by-case basis. If you do not wish to accept cookies from our service providers and partners, you should have your web browser set to “block third-party cookies” or similar. Usually, the “Help” function in the menu bar of your web browser shows you how to deactivate or delete cookies already stored there and how to decline new cookies. For details of the options described, please refer to the instructions provided by your web browser manufacturer.",
                    describtionTwo:
                      "Please note that if you delete without blocking, any essential cookies will be used the next time and we may ask you once again for your consent to optional cookies when you access our website at a later date. Please also note that deactivating or deleting or blocking essential cookies may affect the performance and functionality of our website and may cause certain features and functions to be unavailable.",
                    describtionThree:
                      "You can manage the settings for the use of optional cookies and the associated data processing at any time in the <a>settings</a> of the consent management service.",
                  },
                  sectionThriteen: {
                    title: "Data recipients",
                    describtion: "We may transmit your data to:",
                    dashOne:
                      "Other companies of the Liebherr Group, provided this is necessary to initiate, perform or terminate a contract, or for our part we have a legitimate interest in the transmission and your predominant legitimate interest is not opposed to this;",
                    dashTwo:
                      "The providers of the functions and any other services you actively use;",
                    dashThree:
                      "Our service providers that we use in order to achieve the above-stated purposes;",
                    dashFour: "The recipient or recipients you specify;",
                    dashFive:
                      "Courts of law, courts of arbitration, authorities or legal advisers, if this is necessary to comply with current law or for the establishment, exercise or defence of legal claims.",
                  },
                  sectionFourteen: {
                    title: "Data transfers to third countries",
                    describtionOne:
                      "The transfer of data to bodies in countries outside the European Union or the European Economic Area (so-called third countries) or to international organisations is only permissible (1) if you have given us your consent or (2) if the European Commission has decided that an adequate level of protection exists in a third country (Article 45 GDPR). If the Commission has not made such a decision, we may only transfer your data to recipients located in a third country if appropriate safeguards are in place (e.g., standard data protection clauses adopted by the Commission or the supervisory authority following a specific procedure) and the enforcement of your data subject rights is ensured or the transfer is permissible in individual cases on the grounds of other legal bases (Article 49 GDPR).",
                    describtionTwo:
                      "Where we transfer your data to third countries, we will inform you of the respective details of the transfer at the relevant points in this data protection declaration.",
                  },
                  sectionFiveteen: {
                    title: "Data erasure and storage period",
                    describtionOne:
                      "We will process your data as long as this is necessary for the respective purpose, unless you have effectively objected to the processing of your data or effectively withdrawn any consent you may have given.",
                    describtionTwo:
                      "Insofar as statutory retention obligations exist, we will be bound to store the data in question for the duration of the retention obligation. Upon expiry of the retention obligation, we will check whether there is any further necessity for the processing. If there is no longer such a necessity, your data will be deleted.",
                  },
                  sectionSixteen: {
                    title: "Data security",
                    describtion:
                      "We use technical and organisational security measures to ensure that your data is protected against loss, inaccurate alteration or unauthorised access by third parties. Moreover, for our part in every case, only authorised persons have access to your data, and this only insofar as it is necessary within the scope of the above-stated purposes. The transmission of all data is encrypted.",
                  },
                },
              },
            },
          },
          // Infotexts
          infotexts: {
            general: {
              key: {
                title: "Product key",
                text: `The product key is the unique character string of a configuration and can be used either to store or to recall the configuration.`,
                linkTitle: "Download manual",
              },
              comparison: {
                title: "My Configurations",
                text: "When you save the configuration, you will find your project under the 'my configurations' section. Of course, you can save several configurations and compare them with each other.",
              },
              downloads: {
                title: "Download formats",
                text: "After registration you are able to download different 3D and image formats or create a data sheet.",
              },
            },
            series260: {
              CT: {
                text: `Depending on the selected connection type, different installation and stroke lengths are possible. Please note that no pre-assembled swivel head can be configured when selecting "fix-mounted"`,
              },
              SD: {
                text: `Piston rod coating double chrome only available from rods Ø 70 up to and including Ø 125 (other coating types available upon request)`,
              },
              EL: {
                text: `The installation length defines the length between the two connection points. A piston rod overlap is possible within the configurable stroke and installation lengths.`,
              },
              HUB: {
                text: `The stroke is shown in a retracted state. 
                Extending the piston rod is possible in the “Stroke displayed" field in the 3D model. 
                \nNon-configurable stroke lengths are possible on request.`,
              },
              POS: {
                text: `Shows the individually displayed travel distance of the stroke. This option is also subsequently fuctional in the CAD model.`,
              },
              MAT: {
                text: `In the standard version, a high-quality single chrome layer with a thickness of 25 μm (±5 μm) is applied. For higher corrosion or impact protection requirements, a hardened piston rod with a double chrome coating is available. This coating ensures at least 96 h in the acetic acid salt spray test (AASS) according to DIN EN ISO 9227 rating 10.`,
              },
              V: {
                text: `To avoid possible damage to the hydraulic cylinder, we recommend venting it prior to the initial startup.
                (Connection thread G 1/4)`,
              },
              COL: {
                text: `In addition to a primer coat, the cylinder can be painted in Liebherr grey.`,
              },
            },
            series380: {
              EL: {
                text: `The installation length defines the length between the two connection points. A piston rod overlap is possible within the configurable stroke and installation lengths. Non-configurable installation lengths are possible on request.`,
              },
              HUB: {
                text: `The stroke is shown in a retracted state.
                Extending the piston rod is possible in the “Stroke displayed" field in the 3D model. 
                \nNon-configurable stroke lengths are possible on request.`,
              },
              POS: {
                text: `Shows the individually displayed travel distance of the stroke. This option is also subsequently functional in the CAD model.`,
              },
              MAT: {
                text: `In the standard, high-quality chrome and nickel-chrome coatings are applied. Depending on the application a coating with normal resistance, (AASS acetic acid salt spray test according to DIN EN ISO 9227 with 96 h) or one with an increased resistance (AASS with 240 h) are used. A seawater coating (AASS with 500 h) can also be supplied. Rating basis for all coatings represents rating 10 according to DIN EN ISO 10289.`,
              },
              DAM: {
                text: `Especially with highly dynamic movements, controlled and smooth entry into the end positions is often important. Optionally, a choice can be made between piston-side and/or rod-side, fixed cushioning. The cushioning setting must be checked individually for each application. The system thus ensures jerk-free and delay-free start-up.`,
              },
              SAE: {
                text: `The position of the rod-side hydraulic port can be selected individually. 
                \nSAE port according to ISO 6162 (6000 PSI).`,
              },
              COL: {
                text: `In addition to a primer coat, the cylinder can be painted in Liebherr grey or in any individual color (according to RAL). If only the primer is selected, no maritime paint finish is available.`,
              },
              TCOL: {
                text: `The maritime coating offers special corrosion protection, especially for applications in seawater environments.`,
              },
              OPT: {
                text: `In order to achieve an improved surface quality of the cylinder tube (outside), mechanical surface finishing is recommended.`,
              },
              RCOL: {
                text: `Please note that if you select an individual RAL colour, the 3D model will not be displayed in the correct colour. However, the selected shade is visible in the product key as well as on the data sheet.`,
              },
              DE: {
                text: "Optionally, our solutions of the 380 bar series-production range are also available as a weight-optimised variant with a CRP wrap. Thus, weight savings of up to 13% are possible. Due to simplified bend calculation, the configurable lengths are partly shorter than in the standard.",
                linkDesc:
                  "For more information about this material, please find:",
                linkTitle: "Liebherr hybrid cylinder | Liebherr",
                url: "https://www.liebherr.com/en/deu/products/components/hydraulics/hybrid-cylinders/hybrid-cylinder.html",
              },
            },
            iso6022: {
              MT: {
                text: `In addition to a primer coat, the cylinder can be painted in Liebherr grey.`,
              },
              CT: {
                text: `Depending on the selected connection type, different installation and stroke lengths are possible. Please note that no pre-assembled swivel head can be configured when selecting "fix-mounted"`,
              },
              SD: {
                text: `Piston rod coating double chrome is only available from rods Ø 70 up to and including Ø 125 (other coating types available upon request)`,
              },
              EL: {
                text: `Piston rod coating double chrome is only available from rods Ø 70 up to and including Ø 125 (other coating types available upon request)`,
              },
              HUB: {
                text: `The stroke is shown in a retracted state.
                Extending the piston rod is possible in the “Stroke displayed" field in the 3D model. 
                \nNon-configurable stroke lengths are possible on request. 
                \nThe position measuring system can be selected up to a maximum stroke length of 2,400mm.`,
              },
              POS: {
                text: `Shows the individually displayed travel distance of the stroke. This option is also subsequently fuctional in the CAD model.`,
              },
              PRV: {
                text: `In the standard version, a high-quality single chrome coating with a thickness of 25 μm (±5 μm) is applied.
                For higher corrosion or impact protection requirements, a hardened piston rod with a double chrome coating is available. This coating ensures at least 96 h in the acetic acid salt spray test (AASS) according to DIN EN ISO 9227 rating 10.`,
              },
              CBA: {
                text: `In order to be able to fit a control block on the rod and base side at the hydraulic port, all hydraulic cylinders of the series can be designated accordingly.
                For this purpose, the relevant area on the respective mounting ring is face-milled according to the illustrations above.`,
              },
              DAM: {
                text: `In order to be able to fit a control block on the rod and base side at the hydraulic port, all hydraulic cylinders of the series can be designated accordingly. For this purpose, the relevant area on the respective mounting ring is face-milled according to the illustrations above.`,
              },
              POSMS: {
                text: `In order to constantly measure and, if necessary, control travel of the hydraulic cylinder, it is necessary to use a position measuring system. The magnetostrictive position measuring system is supplied with a device plug (6-pin) and analog output 20...4mA (alternative outputs upon request). Once a position measuring system is chosen, no proximity switch can be selected.`,
              },
              PS: {
                text: `An inductive proximity switch can be used to detect the end positions of a hydraulic cylinder. This option is not applicable if a position measuring system has been selected beforehand. Proximity switch with M12x1 thread; Electrical version PNP - closing function; IP65,68,69; Voltage 10...36V.`,
              },
              V: {
                text: `In order to avoid possible damage to the hydraulic cylinder, we recommend venting it prior to the initial startup.
                (Connection thread G 1/4)`,
              },
              COL: {
                text: `In addition to a primer coat, the cylinder can be painted in Liebherr grey.`,
              },
            },
          },
        },
      },
      de: {
        translation: {
          //COMPONENTS
          AddComparisonButton: {
            config: "Konfig. ",
            savedToast:
              'Konfiguration wurde unter "Meine Konfigurationen" gespeichert.',
            addToComparison: "Produkt zu 'Meine Konfiguration' hinzufügen?",
            comparisonInfo:
              "Mit dem Punkt 'Meine Konfiguration' in der Seitenleiste können Sie Konfigurationen zwischenspeichern und Daten vergleichen. Um diese Konfiguration besser wiederfinden zu können, können Sie nun optional einen Namen und weitere Notizen speichern.",
            saveConfiguration: "Für Vergleich Speichern",
            cancelButton: "Abbrechen",
            customNameLabel: "Name der Konfiguration",
            customNamePlaceholder: "Name der Konfiguration",
            customNameRequired: "Eine Eingabe ist erforderlich",
            customNotesLabel: "Sonstige Notizen zur Konfiguration",
            saveConfig: "Konfiguration speichern",
          },
          Spinner: {
            loadProduct:
              "Bitte haben Sie noch etwas Geduld.. Ihr individuelles Produkt wird gerade für Sie erstellt.",
            loadPreview: "Vorschaubild wird geladen.",
          },
          NotRightProductDiv: {
            question: "Nicht das richtige Produkt für Sie dabei? Kein Problem.",
            question2:
              "Neben den Serienbaureihen bieten wir auch individuelle Sonderlöungen an. ",
            support: "Wir unterstützen Sie gerne.",
            support2: "Bitte kontaktieren Sie uns",
            support3:
              "Oder nutzen Sie direkt das Kontaktformular für eine Sonderanfrage.",
            offer:
              "Für Sie war noch nicht das Richtige dabei? Wir arbeiten gerne ein individuelles Angebot für Sie aus.",
          },
          GoBackModal: {
            //in BackButton and Nav
            preventGoingBackTitle: "Zur Startseite zurückkehren?",
            preventGoingBackText:
              "Sie verlieren den Fortschritt Ihrer Konfiguration.",
            preventGoingBackConfirmButton: "Zurück",
            cancelButton: "Abbrechen",
          },
          FormatSelector: {
            downloadPDF: "PDF Datenblatt herunterladen",
            PDFThumbnailAlt:
              "Beispiel für PDF Datasheet mit Tabelle und Modellvorschau",
            multiselectLabel: "Andere Formate",
            multiselectPlaceholder: "Formate auswählen",
            multiselectPlaceholderText: "Formate durchsuchen",
            multiselectSelectAllText: "Alle auswählen",
            multiselectDeselectAllText: "Alle abwählen",
            download: "Download",
            loading: "Laden...",
          },
          KeyButton: {
            copy: "Kopieren",
            message: "Produktschlüssel in Zwischenablage kopiert",
            title: "Produktschlüssel eingeben",
            confirmButton: "Fortfahren",
            cancelButton: "Abbrechen",
          },
          MainNavigation: {
            portalName: "Hydraulikzylinder",
            configurator: "Konfigurator",
            myProjects: "Meine Konfigurationen",
          },
          Nav: {
            portalName: "Hydraulikzylinder",
          },
          SendButton: {
            requestOffer: "Jetzt Angebot anfordern",
            requestOfferDemo: "Jetzt Link teilen",
            requestOfferShort: "Angebot anfordern",
            requestOfferShortDemo: "Link teilen",
            tooShort: "Zu kurz!",
            validEmail: "E-Mail muss gültig sein!",
            offerModalTitle: "Angebot anfordern",
            offerModalTitleDemo: "Link über E-Mail Adresse teilen",
            offerModalConfirm: "Senden",
            offerModalCancel: "Abbrechen",
            general: "Allgemein",
            firstNameLabel: "Vorname",
            firstNamePlaceholder: "Vorname eingeben",
            lastNameLabel: "Nachname",
            lastNamePlaceholder: "Nachname eingeben",
            companyLabel: "Firma",
            companyPlaceholder: "Firmenname angeben",
            emailLabel: "E-Mail",
            emailPlaceholder: "E-Mail Adresse eingeben",
            phoneLabel: "Telefonnummer",
            phonePlaceholder: "Telefonnummer eingeben",
            usageLabel: "Applikation/Branche (optional)",
            usagePlaceholder:
              "Informationen zur Nutzung des Produktes hinzufügen",
            usageInfo: "ggf. Gerätenamen",
            delivery: "Lieferung",
            enterQuantity: "Menge angeben",
            firstDelivery: "Erforderliche Stückzahl Erstlieferung",
            quantitySeries: "Erforderliche Losgröße in Serie",
            quantityAnnual: "Erforderliche jährliche Menge",
            deliveryTimeLabel: "Gewünschter Zeitpunkt der Lieferung",
            deliveryTimePlaceholder: "Lieferzeitpunkt auswählen",
            annotation: "Anmerkung",
            annotationLabel: "Anmerkung (optional)",
            annotationPlaceholder: "Anmerkung hinzufügen",
            consentSavingContactData:
              "Kontaktdatenspeicherung im Local Storage",
            consentSavingContactDataDesc:
              "Die im Formular eingegebenen Kontaktdaten speichern wir bei Aktivierung im Local Storage. Daraufhin werden zukünftige Formulare automatisch mit diesen Daten vorausgefüllt.",
            error: "Fehler:",
            privacySettings: "Datenschutzeinstellungen",
            required: "Bitte füllen Sie alle Pflichtfelder aus.",
            zipLabel: "PLZ",
            zipPlaceholder: "PLZ angeben",
            cityLabel: "Stadt",
            cityPlaceholder: "Stadt angeben",
            streetLabel: "Straße",
            streetPlaceholder: "Straße angeben",
            countryLabel: "Land",
            countryPlaceholder: "Land auswählen",
            contactQuestion: "Hatten Sie schon Kontakt zu Liebherr?",
            myLiebherrLogin:
              "Melden Sie sich bei MyLiebherr an, um dieses Formular automatisch mit Ihren Kontaktdaten auszufüllen.",
            myLiebherrLogout:
              "Abmelden bei MyLiebherr. Dadurch werden die Kontaktdaten mit den zuvor gespeicherten Daten zurückgesetzt.",
          },
          Sidebar: {
            myConfigs: "Meine Konfigurationen",
            profile: "Profil",
            contact: "Kontakt",
          },
          Sticky: {
            myConfigs: "Meine Konfigurationen",
            contact: "Kontakt",
          },
          EditProfileButton: {
            editModalConfirm: "Speichern",
            editModalCancel: "Abbrechen",
          },
          Dropdown: {
            reset: "Filter entfernen",
          },
          //PAGES
          contact: {
            desc: "Nehmen Sie mit uns Kontakt auf! Gerne beantworten wir Ihre Fragen zu unseren Komponenten und stellen Ihnen ein individuelles Angebot zusammen.",
            link: "Kontaktformular Liebherr-Components",
            contact: "Unsere Kollegen stehen Ihnen gerne zur Verfügung",
            heinz: "Michael Heinz",
            website: "www.liebherr.de",
            websiteContact: "Kontaktformular Liebherr-Components",
            url: "https://www.liebherr.com/de/deu/produkte/komponenten/hydraulik/hydraulikzylinder/hydraulikzylinder.html",
            contactUrl:
              "https://www.liebherr.com/de/deu/specials/komponenten-kontaktformular/kontaktformular.html",
          },
          compare: {
            compareTitle: "Produktvergleich",
            noNotes: "keine Notizen",
            open: "Öffnen",
            errorMessage: "Ausgewähltes Element nicht in Elementen gefunden",
          },
          configurator: {
            partKeyError: "Produktschlüssel konnte nicht zugeordnet werden",
            start: "Start",
            configuration: "Konfiguration",
            summary: "Zusammenfassung",
            affordanceToInput: "Jetzt eingeben",
            next: "Weiter",
          },
          downloads: {
            downlaods: "Downloads",
          },
          finder: {
            finderTitle: "Auswahlassistent",
            finderDesc:
              "Durch die Eingabe technischer Angaben, wie beispielsweise den Systemdruck, schlagen wir Ihnen ein passendes Produkt innerhalb unserer Serienbaureihen vor. \n Führen Sie die Konfiguration anschließend anhand bereits ausgewählter Merkmale fort. \n Bitte beachten Sie im Vorschlag die unterschiedlichen Optionen innerhalb der ausgewählten Baureihe. ",
            results: "Ergebnisse",
            range: "Bereich",
            rangeTo: "bis",
            series260: "Serienbaureihe 260 bar",
            series380: "Serienbaureihe 380 bar",
            seriesISO6022: "Serienbaureihe nach ISO 6022",
            start: "Starten",
            suggestionTitle: "Unser Vorschlag für Sie:",
            matchTitle: "Welche Serienbaureihe passt zu Ihnen?",
            scopeTitle: "Ihre Möglichkeiten",
            scopeDescribtion:
              "In dieser Serienbaureihe stehen Ihnen folgende Optionen zur Verfügung:",
            describtionSeries260:
              "Geschweißter Hydraulikzylinder mit verschiedensten Befestigungsarten für mobile und stationäre Applikationen bis 260 bar",
            describtionSeries380:
              "Dauerfester Hydraulikzylinder für dynamische Anwendungen bis 380 bar",
            describtionSeriesISO6022:
              "Geschraubter Normzylinder mit vielen Ausstattungsoptionen bis 250 bar",
            series260Option1: "Entlüftung",
            series260Option2: "Gelenkkopf",
            series380Option1: "Endlagendämpfung",
            series380Option2: "Sonderlackierung",
            series380Option3: "Seewasserbeständigkeit",
            seriesISO6022Option1: "Endlagendämpfung",
            seriesISO6022Option2: "Näherungsschalter",
            seriesISO6022Option3: "Wegmesssystem",
            seriesISO6022Option4: "Entlüftung",
            empty:
              "Keine passenden Ergebnisse gefunden. Probieren Sie die Werte anzupassen.",
            pressure: "Systemdruck",
          },
          myconfigs: {
            myconfigsTitle: "Meine Konfigurationen",
            goToMyconfigs: "Zu 'Meine Konfigurationen'",
            goToComparison: "Zum Vergleich",
            compare: "Vergleichen",
            preview: "Vorschau",
            id: "Identifikation",
            actions: "Aktionen",
            details: "Details",
            open: "Öffnen",
            remove: "Entfernen",
            data: "Daten",
            nothingSaved: "Keine gespeicherten Konfigurationen vorhanden.",
            comparisonInfo:
              "Wählen Sie in der Tabelle darunter bis zu drei Konfigurationen zum Vergleich aus",
          },
          profile: {
            profileTitle: "Meine Profildaten",
            edit: "Bearbeiten",
            list: '[{"label": "Name", "value": "John Doe"}, {"label": "E-Mail", "value": "test@test.test"}, {"label": "Firma", "value": "Test Company"}, {"label": "Straße", "value": ""}, {"label": "PLZ, Ort", "value": ""}, {"label": "Land", "value": ""}]',
          },
          loginTitle: "Liebherr Login",
          loginText: "Sie sind nicht eingeloggt.",
          registerText: "Sie haben noch kein Account?",
          registerLink: "Jetzt Registrieren.",
          loggedinText: "Eingeloggt als",
          logOut: "Ausloggen",
          footerLinks:
            '[{"label": "Impressum, Datenschutzrichtlinien und Rechtliches", "itemId": "imprint"},{"label": "Datenschutzeinstellungen", "itemId": "cmp", "to": "javascript:usercentrics.showSettings();", "target": "_self"}]',
          start: {
            selectSeries: "Serienbaureihe auswählen",
            series260: "Serienbaureihe 260 bar",
            series380: "Serienbaureihe 380 bar",
            seriesISO6022: "Serienbaureihe nach ISO 6022",
            series260content: "Für mobile und stationäre Einsätze",
            series380content: "Für den mobilen Einsatz",
            seriesISO6022content: "Für den stationären Einsatz",
            start: "Starten",
            whichSeries: `Sie wissen nicht welche Serienbaureihe zu Ihnen passt?
              Wir sagen es Ihnen!`,
            toAssistant: "Zum Auswahlassistent",
            haveKey: "Haben Sie bereits einen Produktschlüssel?",
            keyInfo:
              "In jedem Konfigurationsschritt aktualisieren wir für Sie den Produktschlüssel. Durch Eingabe des Produktschlüssels können Sie Ihre Konfiguration zu einem späteren Zeitpunkt erneut aufrufen.",
            enterKey: "Produktschlüssel eingeben",
            loadConfig: "Konfiguration laden",
          },
          summary: {
            partKeyError: "Produktschlüssel konnte nicht zugeordnet werden",
            pistonRod: "Kolben- / Stangendurchmesser",
            length: "Einbaulänge / Hub",
            myConfig: "Meine Konfiguration",
            download: "Formate herunterladen",
            more: "Weitere Daten",
            sae: "SAE-Anschluss",
            paint: "Lackierung",
            rcol: "RAL-Nummer:",
          },
          confirm: {
            title: "Vielen Dank. Ihre Anfrage wurde erfolgreich gesendet.",
          },
          imprint: {
            title: "Impressum, Datenschutz und rechtliche Informationen",
            termsAndConditions: {
              title: "Rechtliche Hinweise",
              describtion:
                "Mit der Verwendung des Konfigurators erkennen Sie an, dass Sie ausschließlich selbst für die Wahrung der Rechte Dritter und der geltenden gesetzlichen Vorgaben durch das konfigurierte Produkt sowie dessen Eignung zu der von Ihnen vorgesehenen Verwendung verantwortlich sind, soweit dies von der gewählten Konfigurierung abhängt. Die Konfiguration dient nur der unverbindlichen allgemeinen Information, ist nicht bindend und stellt kein Verkaufsangebot dar. Ein konkretes Angebot sowie weitere Details erhalten Sie ggf. nach Absenden einer Anfrage mit dem Konfigurationsschlüssel. Irrtümer bleiben vorbehalten. Die Lieferung des konfigurierten Produkts unterliegt unseren ",
              link: "AGBs Liebherr-Components GmbH",
            },
            imprint: {
              title: "Impressum",
              addressTitle: "Adresse:",
              address: `Liebherr-Components Kirchdorf GmbH \n St. Vitus 5 \n 88457 Kirchdorf an der Iller \n Deutschland`,
              telTitle: "Tel.:",
              tel: "+497354 80 - 8448",
              emailTitle: "E-Mail:",
              email: "info.cok@liebherr.com",
              emailDataProtection: "datenschutz.cok@liebherr.com",
              emailDataProtection2: "datenschutz@liebherr.com",
              managementTitle: "Geschäftsführung:",
              management: "Ulrich Hammerle \n Thomas Sonntag",
              vatTitle: "Ust-Ident.-Nr.:",
              vat: "DE 289151259",
              companiesRegisterTitle: "Handelsregister:",
              companiesRegister: "Amtsgericht Ulm, HRB 729181",
              contactTitle: "Kontakt",
              companyName: "Liebherr-Components Kirchdorf GmbH",
              contactAdress: `St. Vitus 5 \n 88457 Kirchdorf an der Iller \n Deutschland`,
              contactAdressDataProtection: `Liebherr-IT Services GmbH \n  St. Vitus 5 \n 88457 Kirchdorf an der Iller \n Deutschland`,
            },
            dataProtection: {
              title: "Datenschutzerklärung ",
              subTitle: "Online Sales Configurator",
              intro:
                "Wir, die Liebherr-Components Kirchdorf Deutschland GmbH, freuen uns über Ihren Besuch auf unseren Webseiten (nachfolgend gesamt auch „Website“) und über Ihr damit bekundetes Interesse an der Firmengruppe Liebherr. \n \n Wir legen größten Wert auf den Schutz und die Sicherheit Ihrer personenbezogenen Daten. Es ist uns daher wichtig, Sie im Folgenden darüber zu informieren, welche personenbezogenen Daten wir von Ihnen zu welchem Zweck verarbeiten und welche Rechte Sie in Bezug auf Ihre personenbezogenen Daten haben.",
              generalInfo: {
                title: "Allgemeine Informationen",
                first: {
                  title:
                    "Was sind personenbezogene Daten und was bedeutet Verarbeitung?",
                  dashOne:
                    "<strong>„Personenbezogene Daten“</strong> (nachfolgend auch „Daten“) sind alle Informationen, die über eine natürliche Person etwas aussagen. Personenbezogene Daten sind dabei nicht nur Informationen, die einen direkten Rückschluss auf eine bestimmte Person zulassen (wie beispielsweise der Name oder die E-Mail-Adresse einer Person), sondern auch Informationen, mit denen mit entsprechendem Zusatzwissen ein Bezug auf eine bestimmte Person hergestellt werden kann. ",
                  dashTwo:
                    "<strong>„Verarbeitung“</strong> meint jegliche Maßnahmen, die mit Ihren personenbezogenen Daten durchgeführt werden (wie beispielsweise das Erheben, das Erfassen, die Organisation, das Ordnen, die Speicherung, die Verwendung oder das Löschen von Daten). ",
                },
                second: {
                  title:
                    "Wer ist der Verantwortliche für die Verarbeitung Ihrer Daten?",
                  describtion:
                    "Der Verantwortliche für die Verarbeitung Ihrer Daten ist die:",
                },
                third: {
                  title:
                    "Wie können Sie unseren Datenschutzbeauftragten erreichen?",
                  subTitle: "Corporate Privacy",
                  describtion:
                    "Unser Datenschutzbeauftragter ist unter folgenden Kontaktdaten zu erreichen:",
                },
                fourth: {
                  title: "Welche Rechte haben Sie als betroffene Person?",
                  sectionOne: {
                    describtion:
                      "Als betroffene Person haben Sie im gesetzlich vorgegebenen Rahmen das Recht auf:",
                    dashOne: "Auskunft über Ihre Daten;",
                    dashTwo:
                      "Berichtigung unrichtiger Daten und Vervollständigung unvollständiger Daten;",
                    dashThree:
                      "Löschung Ihrer Daten, insbesondere wenn (1) diese für die in dieser Datenschutzerklärung genannten Zwecke nicht mehr notwendig sind, (2) Sie Ihre Einwilligung widerrufen und eine anderweitige Rechtsgrundlage für die Verarbeitung fehlt, (3) Ihre Daten unrechtmäßig verarbeitet wurden oder (4) Sie Widerspruch gegen die Verarbeitung eingelegt haben und keine vorrangigen berechtigten Gründe für die Verarbeitung vorliegen;",
                    dashFour:
                      "Einschränkung der Verarbeitung Ihrer Daten, insbesondere wenn die Richtigkeit der Daten von Ihnen bestritten wird oder die Verarbeitung Ihrer Daten unrechtmäßig ist und Sie anstelle der Löschung die Einschränkung der Nutzung verlangen;",
                    dashFive:
                      "Widerspruch gegen eine zur Wahrung berechtigter Interessen erfolgende Verarbeitung Ihrer Daten aus Gründen, die sich aus Ihrer besonderen Situation ergeben oder, ohne besondere Begründung, gegen Verarbeitungen Ihrer Daten, die zum Zweck der Direktwerbung erfolgen; sofern es sich nicht um einen Widerspruch gegen Direktwerbung handelt, bitten wir bei Einlegung eines Widerspruchs um die Darlegung der Gründe, weshalb wir Ihre Daten nicht wie ggf. von uns durchgeführt verarbeiten sollen. Im Falle Ihres begründeten Widerspruchs prüfen wir die Sachlage und stellen die Verarbeitung ein, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen;",
                    dashSix:
                      "Erhalt Ihrer Daten in einem strukturierten, gängigen und maschinenlesbaren Format sowie das Recht, zu erwirken, dass Ihre Daten von uns direkt an einen anderen Verantwortlichen übermittelt werden;",
                    dashSeven:
                      "Widerruf der Einwilligung, sofern Sie uns eine Einwilligung zur Verarbeitung erteilt haben. Bitte beachten Sie, dass die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung von Ihrem Widerruf unberührt bleibt.",
                  },
                  sectionTwo: {
                    describtion: `Bei einer Geltendmachung der oben genannten Rechte, bitten wir um Verständnis dafür, dass wir gegebenenfalls Nachweise von Ihnen verlangen, die belegen, dass Sie die Person sind, für die Sie sich ausgeben. 
                      \n Darüber hinaus besteht für Sie ein Recht auf Beschwerde bei einer Aufsichtsbehörde, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer Daten gegen die DSGVO verstößt.`,
                  },
                },
                fifth: {
                  title: "Links zu anderen Websites",
                  describtion:
                    "Unsere Website kann Links zu und von Websites anderer, mit uns nicht verbundener Anbieter („Dritter“) enthalten. Nach Anklicken des Links haben wir keinen Einfluss mehr auf die Verarbeitung etwaig mit dem Anklicken des Links an den Dritten übertragener Daten (wie zum Beispiel der IP-Adresse oder der URL, auf der sich der Link befindet), da das Verhalten Dritter naturgemäß unserer Kontrolle entzogen ist. Für die Verarbeitung derartiger Daten durch Dritte können wir daher keine Verantwortung übernehmen.",
                },
              },
              dataProcessing: {
                title: "Datenverarbeitung",
                first: {
                  title: "Logfiles",
                  describtion:
                    "Bei jedem Aufruf und der Nutzung unserer Website werden durch den auf Ihrer Endeinrichtung (Computer, Smartphone oder Ähnliches) zum Einsatz kommenden Webbrowser automatisch Informationen an unsere Webserver gesendet, die wir in sogenannten Logfiles speichern.",
                  sectionOne: {
                    title: "Welche Daten verarbeiten wir zu welchen Zwecken?",
                    describtion: "Wir verarbeiten folgende Daten:",
                    dashOne: "Ihre (externe) IP-Adresse",
                    dashTwo: "Datum und Uhrzeit des Aufrufs",
                    dashThree: "Domainname Ihres Internet-Zugangsanbieters",
                    dashFour:
                      "Der von Ihnen verwendete Browsertyp und -version und das von Ihnen verwendete Betriebssystem",
                    dashFive:
                      "URL (Adresse im Internet) derjenigen Webseite, auf der Sie sich zum Zeitpunkt des Aufrufs befunden haben",
                    dashSix:
                      "Die von Ihnen über die jeweilige Webseite abgerufenen Dateien (Zugriffsart, Name der abgerufenen Datei, URL der abgerufenen Datei, Erfolg des Abrufs)",
                    dashSeven:
                      "Die an Sie beim Besuch der jeweiligen Webseite übertragene Datenmenge",
                    dashEight:
                      "Ggf. Absendedatum, -uhrzeit bei der Nutzung von Webformularen",
                  },
                  sectionTwo: {
                    describtionOne:
                      "Diese Daten verarbeiten wir grundsätzlich nur zum Zwecke der Gewährleistung der Stabilität sowie Netz- und Informationssicherheit.",
                    describtionTwo:
                      "Eine Verarbeitung zu anderen Zwecken kommt nur dann in Betracht, wenn die insoweit erforderlichen rechtlichen Vorgaben gemäß Art. 6 Abs. 4 DSGVO vorliegen. Etwaige Informationspflichten nach Art. 13 Abs. 3 DSGVO und Art. 14 Abs. 4 DSGVO werden wir in dem Fall selbstverständlich beachten.",
                  },
                  sectionThree: {
                    title:
                      "Auf welcher rechtlichen Grundlage verarbeiten wir Ihre Daten?",
                    describtionOne:
                      "Die Verarbeitung Ihrer Daten erfolgt zur Wahrung berechtigter Interessen gemäß Art. 6 Abs. 1 lit. f DSGVO.",
                    describtionTwo:
                      "Unsere verfolgten berechtigten Interessen sind die Verbesserung und Aufrechterhaltung der Stabilität bzw. Funktionalität und die Sicherung unserer Website.",
                    describtionThree:
                      "Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit der Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO zu widersprechen.",
                  },
                },
                second: {
                  title: "Authentifizierung/Autorisierung",
                  describtion:
                    "Die Authentifizierung auf unserer Website erfolgt unter Verwendung eines bestehenden Liebherr-Kontos bei der Liebherr-IT Services GmbH, St. Vitus 5, 88457 Kirchdorf an der Iller, Deutschland.",
                  sectionOne: {
                    title: "Welche Daten verarbeiten wir zu welchen Zwecken?",
                    describtionOne: "Wir verarbeiten folgende Daten:",
                    dashOne:
                      "Eindeutige Nutzerkennung (UPN) \n <strong>Hinweis:</strong> Dieses Datum wird bei einer Authentifizierung mit einem Liebherr-Konto von der Liebherr-IT Services GmbH an uns übermittelt.",
                    describtionTwo:
                      "Diese Daten verarbeiten wir grundsätzlich nur zum Zwecke der Authentifizierung auf unserer Website bzw. der zentralen Authentifizierung im Rahmen der Nutzung von nichtöffentlich verfügbaren Inhalten.",
                    describtionThree:
                      "Eine Verarbeitung zu anderen Zwecken kommt nur dann in Betracht, wenn die insoweit erforderlichen rechtlichen Vorgaben gemäß Art. 6 Abs. 4 DSGVO vorliegen. Etwaige Informationspflichten nach Art. 13 Abs. 3 DSGVO und Art. 14 Abs. 4 DSGVO werden wir in dem Fall selbstverständlich beachten.",
                  },
                  sectionTwo: {
                    title:
                      "Auf welcher rechtlichen Grundlage verarbeiten wir Ihre Daten?",
                    describtion:
                      "Die Verarbeitung Ihrer Daten erfolgt zur Erfüllung eines Vertrags oder zur Durchführung vorvertraglicher Maßnahmen gemäß Art. 6 Abs. 1 lit. b DSGVO.",
                  },
                },
                third: {
                  title: "Kontaktformular",
                  describtion:
                    "Wir bieten Ihnen auf unserer Website die Möglichkeit, über Webformulare Anfragen an uns oder an andere Unternehmen zu versenden. Wenn Sie diese Möglichkeit wahrnehmen, übermitteln wir Ihre über das jeweilige Formular erhobenen Daten per E-Mail an den von Ihnen ausgewählten Adressaten. Sofern wir selbst Adressat Ihrer Anfrage sein sollten, verarbeiten wir Ihre Daten zudem, um Ihre Nachricht oder Anfrage zu bearbeiten und mit Ihnen Kontakt aufzunehmen.",
                  sectionOne: {
                    title: "Welche Daten verarbeiten wir zu welchen Zwecken?",
                    describtion: "Wir verarbeiten folgende Daten:",
                    dashOne: "Vor- und Nachname (bei Angebotserstellung)",
                    dashTwo: "Firmenname (bei Angebotserstellung)",
                    dashThree: "Anschrift (bei Angebotserstellung)",
                    dashFour: "E-Mail-Adresse (bei Angebotserstellung)",
                    dashFive: "Telefonnummer (bei Angebotserstellung)",
                    dashSix: "Lieferadresse (bei Angebotserstellung)",
                  },
                  sectionTwo: {
                    describtionOne:
                      "Diese Daten verarbeiten wir grundsätzlich nur für folgende Zwecke:",
                    dashOne:
                      "Leistungserbringung (Übermittlung Ihrer Nachricht oder Anfrage an den Adressaten)",
                    dashTwo:
                      "Ihre Daten werden zum Zweck der Angebotserstellung und Kontaktaufnahme an den zuständigen Verkäufer oder Händler übermittelt. Diese Verkäufer bzw. Händler sind ausschließlich im von uns vorgegebenen Rahmen berechtigt diese Daten zu verarbeiten und wurden von uns verpflichtet, diese Daten nach Erfüllung des Dienstleistungsvertrages bzw. Zweckerfüllung zu löschen.",
                    dashThree:
                      "Beantwortung und weitere Bearbeitung Ihrer Nachricht oder Anfrage, sofern wir selbst Adressat Ihrer Nachricht oder Anfrage sind",
                    describtionTwo:
                      "Eine Verarbeitung zu anderen Zwecken kommt nur dann in Betracht, wenn die insoweit erforderlichen rechtlichen Vorgaben gemäß Art. 6 Abs. 4 DSGVO vorliegen. Etwaige Informationspflichten nach Art. 13 Abs. 3 DSGVO und Art. 14 Abs. 4 DSGVO werden wir in dem Fall selbstverständlich beachten.",
                  },
                  sectionThree: {
                    title:
                      "Auf welcher rechtlichen Grundlage verarbeiten wir Ihre Daten?",
                    describtion:
                      "Die Verarbeitung Ihrer Daten erfolgt aufgrund folgender Rechtsgrundlage(n):",
                    dashOne:
                      "Erfüllung eines Vertrags oder Durchführung vorvertraglicher Maßnahmen (Art. 6 Abs. 1 lit. b DSGVO)",
                    dashTwo:
                      "Erfüllung einer rechtlichen Verpflichtung (Art. 6 Abs. 1 lit. c DSGVO)",
                  },
                },
                fourth: {
                  title: "Einsatz von Cookies und weiteren Technologien",
                  sectionOne: {
                    title: "A. Allgemeines",
                    describtion:
                      "Im Rahmen der Bereitstellung unserer Website setzen wir Cookies und weitere Technologien ein. Mit den nachfolgenden Cookie-Hinweisen stellen wir Ihnen als Nutzer unserer Website zusätzliche Informationen zu der Datenverarbeitung beim Einsatz von Cookies und weiteren Technologien bereit.",
                  },
                  sectionTwo: {
                    title: "I. Was sind Cookies und weitere Technologien?",
                    describtionOne:
                      "<strong>Cookies</strong> sind kleine Textdateien, die ein Webserver mittels des von Ihnen genutzten Webbrowsers auf Ihrer Endeinrichtung (Computer, Smartphone oder Ähnliches) speichern und auslesen kann. Cookies enthalten individuelle alphanumerische Zeichenfolgen, die eine Identifizierung des von Ihnen verwendeten Webbrowsers ermöglichen und auch Informationen zu nutzerorientierten Einstellungen enthalten können.",
                    describtionTwo:
                      "Neben Cookies verwenden wir folgende weitere Technologien:",
                    dashOne:
                      "Mit der sogenannten <strong>Local-Storage-Technik</strong> werden Daten nur lokal, also ausschließlich auf Ihrer Endeinrichtung und nicht auf dem Webserver, im sogenannten Local Storage Ihres Webbrowsers gespeichert. Im Unterschied zu Cookies besitzen die per Local-Storage-Technik gespeicherten Daten kein Verfallsdatum und werden nicht ohne Weiteres automatisch gelöscht, grundsätzlich können Sie diese Daten jedoch selbst über ihren Webbrowser löschen. Wie Sie die per Local-Storage-Technik gespeicherten Daten löschen können, entnehmen Sie bitte der Anleitung Ihres Webbrowser-Herstellers.",
                    dashTwo:
                      "Zusätzlich haben wir sogenannte <strong>Zählpixel</strong> (auch: „Pixel“, „Pixel-Tags“ oder „Webbeacons“) auf unserer Website eingebunden. Zählpixel sind kleine, meist unsichtbare Bilddateien, die von einem Webserver automatisch geladen werden und dabei Informationen über Ihren Webbrowser oder Ihre Endeinrichtung sowie zu Ihrer Nutzung unserer Website liefern können. Aus diesen Informationen kann wiederum ein Profil erstellt werden, welches beim erneuten Besuch unserer Website wiedererkannt wird.",
                    describtionThree:
                      "Die vorstehend genannten Cookies und weiteren Technologien werden nachfolgend zusammen auch „Cookies“ genannt.",
                  },
                  sectionThree: {
                    title:
                      "II. Welche Arten von Cookies und weiteren Technologien gibt es?",
                    describtionOne:
                      "Wir unterscheiden zwischen einerseits erforderlichen und andererseits optionalen Cookies:",
                    dashOne:
                      "<strong>Erforderliche Cookies</strong> sind solche, die technisch für die Funktionalität sowie zur Gewährleistung der Sicherheit und Stabilität unserer Website und informationstechnischen Systeme erforderlich sind. Wir ordnen dieser Kategorie auch solche Cookies zu, die bestimmte von Ihnen vorgenommene Einstellungen, ausgewählte Optionen oder eingegebene Informationen längstens bis zum Schließen Ihres Webbrowsers speichern, um die von Ihnen gewünschte und angeforderte Funktion zur Verfügung zu stellen (z.B. Login-Status, Spracheinstellung etc.). Für die Speicherung oder das Auslesen von erforderlichen Cookies ist Ihre Einwilligung nicht erforderlich. Daher können Sie erforderliche Cookies auch nicht über die <a>Einstellungen</a> des von uns eingesetzten Einwilligungsverwaltungsdienstes, sondern nur über Ihren Webbrowser verwalten und dort gespeicherte Cookies löschen bzw. die Speicherung von Cookies blockieren.",
                    dashTwo:
                      "<strong>Optionale Cookies</strong> sind solche, die für die Funktionalität sowie zur Gewährleistung der Sicherheit und Stabilität unserer Website und informationstechnischen Systeme nicht erforderlich sind, sondern Analyse- oder Marketingzwecken dienen. Diese Cookies können beispielsweise zur Erstellung anonymisierter Statistiken Informationen darüber erfassen, wie Sie unsere Website nutzen, was uns eine Analyse der Nutzung und damit Optimierungen unserer Website ermöglicht. Darüber hinaus ordnen wir dieser Kategorie auch solche Cookies zu, die bestimmte von Ihnen vorgenommene Einstellungen, ausgewählte Optionen oder eingegebene Informationen über das Schließen Ihres Webbrowsers hinaus speichern, um die von Ihnen gewünschte und angeforderte Funktion längerfristig zur Verfügung zu stellen (z.B. Login-Status über die Auswahl „Merke meine E-Mail-Adresse“, Merkzettel, Vergleichsliste etc.). Für die Speicherung oder das Auslesen von optionalen Cookies ist grundsätzlich Ihre vorherige Einwilligung erforderlich. Über die <a>Einstellungen</a> des von uns eingesetzten Einwilligungsverwaltungsdienstes können Sie in den Einsatz optionaler Cookies einwilligen und erteilte Einwilligungen jederzeit mit Wirkung für die Zukunft widerrufen.",
                    describtionTwo:
                      "Sowohl bei erforderlichen als auch optionalen Cookies kann es sich um sogenannte Sitzungs-Cookies oder beständige Cookies handeln, die sich hinsichtlich ihrer vorgesehenen Lebens- bzw. Funktionsdauer unterscheiden:",
                    dashThree:
                      "<strong>Sitzungs-Cookies</strong> (auch: Session Cookies) werden auf Ihrer Endeinrichtung gespeichert und automatisch gelöscht, wenn Sie Ihren Webbrowser schließen.",
                    dashFour:
                      "<strong>Beständige Cookies</strong> (auch: permanente Cookies oder Persistent Cookies) werden auf Ihrer Endeinrichtung gespeichert und nach dem Schließen Ihres Webbrowsers nicht automatisch gelöscht, sondern verbleiben für eine vordefinierte Zeit auf Ihrer Endeinrichtung.",
                    dashFive:
                      "Die per <strong>Local-Storage-Technik</strong> gespeicherten Daten besitzen kein Verfallsdatum, haben also eine zeitlich unbegrenzte Funktionsdauer.",
                    describtionThree:
                      "<strong>Hinweis:</strong> Sie können Cookies sowie die per Local-Storage-Technik gespeicherten Daten grundsätzlich selbst über ihren Webbrowser löschen. Einzelheiten dazu entnehmen Sie bitte der Anleitung Ihres Webbrowser-Herstellers.",
                  },
                  sectionFour: {
                    title: "B. Einsatz von Cookies auf unserer Website",
                  },
                  sectionFive: {
                    title: "I. Erforderliche Cookies",
                    subtitle:
                      "1. Welche erforderlichen Cookies werden zu welchem Zweck wie lange eingesetzt?",
                    table: {
                      columnOne: "Dienst",
                      columnTwo: "Zweck",
                      columnThree: "Diensteanbieter",
                      columnFour: "Funktionsdauer",
                      rowOne: {
                        1: "Einwilligungsverwaltung",
                        2: "Einholung und Verwaltung von Einwilligungen sowie Speicherung von Informationen über Einwilligungsentscheidungen",
                        3: `Usercentrics GmbH, \n
                              Sendlinger Straße 7, \n
                              80331 München, Deutschland`,
                        4: "unbegrenzt",
                      },
                      rowTwo: {
                        1: "Content Delivery Network",
                        2: "Sicherheit und Stabilität",
                        3: `Cloudflare, Inc., \n
                              101 Townsend St, \n
                              San Francisco, CA 94107, USA`,
                        4: "30 Tage",
                      },
                      rowThree: {
                        1: "Load Balancer",
                        2: "Sicherheit und Stabilität",
                        3: "-",
                        4: "8 Stunden",
                      },
                      rowFour: {
                        1: "Spracherkennung",
                        2: "Spracherkennung zur nutzerorientierten Sprachanzeige der Website",
                        3: "-",
                        4: "Bis zum Schließen Ihres Webbrowsers",
                      },
                    },
                    dashOne: `<strong>Einwilligungsverwaltung</strong> <br><br>
                      <a>Einstellungen öffnen</a> <br>
                      Damit Sie den Einsatz optionaler Cookies auf unserer Website verwalten können, haben wir einen Einwilligungsverwaltungsdienst implementiert. Über den Einwilligungsverwaltungsdienst wird Ihnen beim erstmaligen Aufruf unserer Website eine vorgeschaltete Abfrage („Cookies, weitere Technologien und sonstige Dienste“) angezeigt, mit der Sie durch einen Klick auf die entsprechende Schaltfläche den Einsatz optionaler Cookies akzeptieren oder ablehnen können. Überdies gelangen Sie mit einem Klick auf „Einstellungen“ zu den <a>Einstellungen</a> des Einwilligungsverwaltungsdienstes, wo Sie u.a. eine vereinfachte, nach Arten gegliederte Cookie-Liste vorfinden. Mit dem Einwilligungsverwaltungsdienst können Sie sich u.a. über die Zwecke der von uns eingesetzten Cookies, über die jeweils verarbeiteten Daten sowie etwaige Datenempfänger informieren und im Falle optionaler Cookies Ihre Einwilligung jederzeit durch Aus- oder Abwahl des entsprechenden Kästchens erteilen beziehungsweise widerrufen. \n\n
                      Bitte beachten Sie, dass erforderliche Cookies bereits bei Aufruf unserer Website gespeichert werden und das diesbezügliche Kästchen vorausgewählt ist. Eine Abwahl erforderlicher Cookies über den Einwilligungsverwaltungsdienst ist nicht möglich. Für die Funktionalität des Einwilligungsverwaltungsdienstes selbst ist wiederum der Einsatz von bestimmten Cookies erforderlich.
                    `,
                    addressTitle0ne: "Informationen des Diensteanbieters:",
                    addressOne:
                      "Usercentrics GmbH, Sendlinger Straße 7, 80331 München, Deutschland",
                    linkTitleOne: "Website:",
                    linkOne: "https://usercentrics.com/de",
                    linkTitleTwo: "Allgemeine Geschäftsbedingungen:",
                    linkTwo: "https://usercentrics.com/de/agb/",
                    linkTitleThree: "Datenschutzerklärung:",
                    linkThree:
                      "https://usercentrics.com/de/datenschutzerklarung/",
                    dashTwo: `<strong>Content Delivery Network</strong>  <br>
                      Zur Optimierung der Ladezeiten unserer Website setzen wir ein sogenanntes Content Delivery Network (nachfolgend „CDN“) ein. Ein CDN ist ein Netzwerk geografisch verteilter und über das Internet verbundener Server, mit dessen Hilfe Webinhalte schneller und sicherer ausgeliefert werden können. Im Rahmen des CDN werden personenbezogene Daten an verschiedene Länder übermittelt; an Länder außerhalb der EU bzw. des EWR, sogenannte Drittländer, erfolgt die Übermittlung unter Einhaltung der in Kapitel V der DSGVO niedergelegten Bedingungen. Mit dem Dienstleister wurden von der EU-Kommission erlassene Standardvertragsklauseln (Art. 46 Abs. 2 lit. c DSGVO) abgeschlossen.
                    `,
                    addressTitleTwo: "Informationen des Diensteanbieters:",
                    addressTwo:
                      "Cloudflare, Inc., 101 Townsend St, San Francisco, CA 94107, USA",
                    addressTitleThree: "Vertreter in der Union:",
                    addressThree:
                      "Cloudflare Portugal, Unipessoal Lda., Largo Rafael Bordalo Pinheiro 29, 1200-369 Lisboa, Portugal",
                    linkTitleFour: "Website:",
                    linkFour: "https://www.cloudflare.com",
                    linkTitleFive: "Datenschutzerklärung (Englisch):",
                    linkFive: "https://www.cloudflare.com/privacypolicy/",
                    linkTitleSix: "Standardvertragsklauseln (Englisch):",
                    linkSix:
                      "https://www.cloudflare.com/cloudflare-customer-scc/",
                    dashThree: `<strong>Load Balancer</strong>  <br>
                      Zur Lastverteilung nutzen wir einen sogenannten Load Balancer. Mit einem Load Balancer werden Webanfragen an einen Lastverteilungsserver geschickt, der die Webanfrage wiederum an einen internen Server weiterleitet. Damit Sie innerhalb einer Sitzung nicht zwischen unterschiedlichen Servern hin und her geleitet werden und eine einheitliche Verarbeitung gewährleistet ist, werden Ihre Webanfragen an denselben Server weitergeleitet. Um jenen Server zu identifizieren und eine korrekte Weiterleitung zu gewährleisten, verwenden wir ein Cookie mit einer Lebens- bzw. Funktionsdauer von acht Stunden.
                    `,
                    dashFour: `<strong>Spracherkennung</strong>  <br>
                      Zur nutzerorientierten Sprachanzeige unserer Website setzen wir ein Sitzungs-Cookie ein. Damit wird die Sprache Ihres Webbrowsers erkannt und Ihnen unsere Website in derselben Sprache angezeigt.
                    `,
                  },
                  sectionSix: {
                    title:
                      "2. Auf welcher Rechtsgrundlage werden erforderliche Cookies eingesetzt?",
                    describtionOne:
                      "Um nachweisen zu können, dass bzw. ob Sie in den Einsatz einwilligungsbedürftiger optionaler Cookies eingewilligt haben, speichern wir die Information über Ihre erteilten bzw. nicht erteilten Einwilligungen zur Erfüllung unserer gesetzlichen Nachweispflicht nach Art. 6 Abs. 1 lit. c, Abs. 3 lit. a DSGVO in Verbindung mit Art. 7 Abs. 1 DSGVO.",
                    describtionTwo:
                      "Überdies setzen wir erforderliche Cookies zur Wahrung berechtigter Interessen nach Art. 6 Abs. 1 lit. f DSGVO ein.",
                    describtionThree:
                      "Unsere verfolgten berechtigten Interessen sind:",
                    dashOne:
                      "Gewährleistung der Sicherheit und Stabilität unserer Website und informationstechnischen Systeme, wie etwa durch Schutz vor Angriffen in Form der gezielten Überlastung von Servern („Denial-of-Service“-Angriffe) oder durch optimale Lastverteilung auf Servern",
                    dashTwo:
                      "Geltendmachung, Ausübung und Verteidigung von Rechtsansprüchen",
                    dashThree:
                      "Bereitstellung und Gewährleistung der ordnungsgemäßen Funktionalitäten unserer Website",
                  },
                  sectionSeven: {
                    title:
                      "3. Wie kann ich dem Einsatz erforderlicher Cookies widersprechen?",
                    describtionOne:
                      "Sie können Ihr Widerspruchsrecht mittels der unten unter „Löschung/Blockierung von Cookies“ beschriebenen Blockier-Möglichkeiten ausüben (vgl. Art. 21 Abs. 5 DSGVO), also das Blockieren erforderlicher Cookies über Ihre Webbrowser-Einstellungen vornehmen.",
                    describtionTwo:
                      "Bitte beachten Sie, dass bei einem Löschen ohne ein Blockieren erforderliche Cookies neu eingesetzt werden, wenn Sie unsere Website zu einem späteren Zeitpunkt erneut aufrufen. Beachten Sie ferner, dass eine Deaktivierung bzw. Löschung oder Blockierung erforderlicher Cookies die Leistung und Funktionalität unserer Website beeinträchtigen und bewirken kann, dass bestimmte Funktionen und Merkmale nicht zur Verfügung stehen.",
                  },
                  sectionEight: {
                    title: "II. Optionale Cookies",
                    describtion:
                      "Mit nachfolgenden Informationen möchten wir Sie in die Lage versetzen, eine fundierte Entscheidung für oder gegen den Einsatz <strong>optionaler Cookies</strong> und die damit verbundene Datenverarbeitung zu treffen.",
                  },
                  sectionNine: {
                    title:
                      "1. Welche optionalen Cookies werden zu welchem Zweck wie lange eingesetzt?",
                    table: {
                      columnOne: "Dienst",
                      columnTwo: "Zweck",
                      columnThree: "Diensteanbieter",
                      columnFour: "Funktionsdauer",
                      rowOne: {
                        1: "Google Analytics",
                        2: "Webanalyse",
                        3: `Google Ireland Limited, \n
                          Gordon House, Barrow Street, \n
                          Dublin 4, Irland
                        `,
                        4: "Bis zu 2 Jahre",
                      },
                      rowTwo: {
                        1: "Google Ads Conversion Tracking",
                        2: "Marketing",
                        3: `Google Ireland Limited, \n
                          Gordon House, Barrow Street, \n
                          Dublin 4, Irland
                        `,
                        4: "Bis zu 2 Jahre",
                      },
                      rowThree: {
                        1: "Google Ads Remarketing",
                        2: "Marketing",
                        3: `Google Ireland Limited, \n
                          Gordon House, Barrow Street, \n
                          Dublin 4, Irland
                        `,
                        4: "Bis zu 2 Jahre",
                      },
                      rowFour: {
                        1: "Google Ad Manager",
                        2: "Marketing",
                        3: `Google Ireland Limited, \n
                          Gordon House, Barrow Street, \n
                          Dublin 4, Irland
                        `,
                        4: "Bis zu 2 Jahre",
                      },
                      rowFive: {
                        1: "Microsoft Advertising",
                        2: "Marketing",
                        3: "Microsoft Ireland Operations Limited, One Microsoft Place, South County Business Park, Leopardstown, Dublin 18, Irland",
                        4: "Bis zu 390 Tage",
                      },
                    },
                    dashOne: `<strong>Webanalyse</strong>\n
                      Vorbehaltlich Ihrer Einwilligung setzen wir Webanalyse-Cookies ein, um die Nutzung unserer Website analysieren und damit stetig verbessern zu können. Über die gewonnenen anonymisierten Nutzerstatistiken (z.B. Zahl und Herkunft der Websitebesucher) können wir unsere Website optimieren und interessanter gestalten, etwa indem häufig aufgerufene Informationen bzw. Themen bedarfsgerecht auf unserer Website platziert werden.\n
                      Vor diesem Hintergrund nutzen wir die nachfolgend aufgeführten Dienste:
                    `,
                    dashTwo: `<strong>Google Analytics</strong>\n
                      Zur Webanalyse verwenden wir „Google Analytics“, einen Webanalysedienst der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland; Mutterunternehmen: Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA (hier nachfolgend zusammen „Google“), mit der Erweiterung der „IP-Anonymisierung“ (auch „IP-Masken-Methode“ genannt). Hierzu haben wir mit Google einen Vertrag zur Auftragsverarbeitung nach Art. 28 DSGVO abgeschlossen. Demnach wird Google die erfassten Daten (Daten zu Ihrer Endeinrichtung oder Ihrem Webbrowser, IP-Adressen und Ihre Website- oder App-Aktivitäten) zweckgebunden in unserem Auftrag verarbeiten, um Ihre Nutzung unserer Website für uns auszuwerten, um Reports über die Websiteaktivitäten zusammenzustellen und um weitere mit der Nutzung unserer Website und der Internetnutzung verbundene Dienstleistungen uns gegenüber zu erbringen.\n\n
                      Die im Rahmen von Google Analytics erfassten Daten können von Google oder Unterauftragsverarbeitern von Google außerhalb der EU bzw. des EWR und damit in einem Drittland, insbesondere in den USA, gespeichert und verarbeitet werden. Durch die von uns eingesetzte IP-Masken-Methode wird indes erreicht, dass vor einer Übermittlung an einen Google-Server in den USA und der dortigen Speicherung eine Kürzung der IP-Adresse noch innerhalb von EU-Mitgliedstaaten oder in anderen EWR-Vertragsstaaten erfolgt, sodass keine vollständige IP-Adresse übermittelt und dadurch die Identifizierbarkeit einer Person verhindert oder wesentlich erschwert wird. Nur in Ausnahmefällen wird die vollständige, das heißt ungekürzte IP-Adresse an einen Server von Google in den USA übermittelt und erst dort gekürzt.\n\n
                      Für eine Datenübermittlung in ein Drittland sind gemäß DSGVO zusätzliche Bedingungen einzuhalten, um sicherzustellen, dass das in der EU gewährleistete Datenschutzniveau nicht untergraben wird. In diesem Fall erfolgt die Datenübermittlung in die USA auf Grundlage des Angemessenheitsbeschlusses der Europäischen Kommission vom 10. Juli 2023. Nach diesem Angemessenheitsbeschluss gewährleisten die USA ein angemessenes Schutzniveau im Sinne des Art. 45 DSGVO für personenbezogene Daten, die aus der EU an Organisationen in den USA übermittelt werden, welche nach dem „EU-U.S. Data Privacy Framework“ (nachfolgend „DPF“) zertifiziert und in der vom US-Handelsministerium geführten und öffentlich zugänglich gemachten „Data Privacy Framework List“ (<strong><a>https://www.dataprivacyframework.gov/s/participant-search</a></strong>) aufgeführt sind.\n\n
                      Google LLC ist nach dem DPF zertifiziert und in der „Data Privacy Framework List“ aufgeführt.
                    `,
                    addressTitle: "Informationen des Diensteanbieters:",
                    address:
                      "Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland; Mutterunternehmen: Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA",
                    linkTitleOne:
                      "Auftragsdatenverarbeitungsbedingungen für Google Werbeprodukte:",
                    linkOne:
                      "https://privacy.google.com/businesses/processorterms/",
                    linkTitleTwo: "Nutzungsbedingungen:",
                    linkTwo:
                      "https://marketingplatform.google.com/about/analytics/terms/de/",
                    linkTitleThree:
                      "Übersicht über die Datennutzung in Google Analytics:",
                    linkThree:
                      "https://support.google.com/analytics/answer/6004245?hl=de",
                    linkTitleFour: "Datenschutzerklärung:",
                    linkFour: "https://policies.google.com/privacy?hl=de",
                    linkTitleFive:
                      "Technische Erläuterung zur „IP-Anonymisierung (oder IP-Maskierung) in Google Analytics“:",
                    linkFive:
                      "https://support.google.com/analytics/answer/2763052?hl=de",
                    describtion: `<strong>Zusatzhinweis:</strong>
                      Wenn Sie Google Analytics websiteübergreifend deaktivieren möchten, können Sie unter der Adresse <strong><a>https://tools.google.com/dlpage/gaoptout?hl=de</a></strong>  das „Browser-Add-on zur Deaktivierung von Google Analytics“ herunterladen und installieren. Diese Möglichkeit verhindert eine Webanalyse nur, solange Sie einen Webbrowser nutzen, auf dem Sie das Add-on installiert haben.
                    `,
                  },
                  sectionTen: {
                    title:
                      "2. Auf welcher Rechtsgrundlage werden optionale Cookies eingesetzt?",
                    describtion:
                      "Wir setzen optionale Cookies auf Grundlage der Einwilligung nach Art. 6 Abs. 1 lit. a in Verbindung mit Art. 7 DSGVO ein.",
                  },
                  sectionEleven: {
                    title:
                      "3. Wie kann ich meine in den Einsatz optionaler Cookies erteilte Einwilligung widerrufen?",
                    linkLabel: "Einstellungen öffnen",
                    link: "javascript:usercentrics.showSettings();",
                    describtionOne:
                      "Beim (erstmaligen) Aufruf unserer Website bitten wir Sie mit einer vorgeschalteten Abfrage („Cookies, weitere Technologien und sonstige Dienste“) u.a. um Ihre Einwilligung für den Einsatz optionaler Cookies. Ihre erteilten Einwilligungen können Sie jederzeit mit Wirkung für die Zukunft widerrufen und damit die weitere Erfassung Ihrer Daten verhindern, indem Sie optionale Cookies (Webanalyse, Marketing) in den <a>Einstellungen</a> des Einwilligungsverwaltungsdienstes abwählen.",
                    describtionTwo:
                      "Sofern und soweit Sie nicht einwilligen oder erteilte Einwilligungen widerrufen, unterbleibt die (weitere) Datenerfassung mittels einwilligungsbedürftiger optionaler Cookies und die damit verbundene Datenverarbeitung. Für die Nutzung der Website hat dies keine Nachteile, soweit Sie nicht auch die Cookie-Funktionen für erforderliche Cookies deaktivieren.",
                    describtionThree:
                      "Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.",
                    describtionFour:
                      "Alternativ zum Widerruf der Einwilligung stehen Ihnen die unten unter „Löschung/Blockierung von Cookies“ beschriebenen Möglichkeiten zur Löschung bzw. Blockierung von Cookies mit den dortigen Hinweisen offen.",
                  },
                  sectionTwelve: {
                    title: "C. Löschung/Blockierung von Cookies",
                    describtionOne:
                      "Cookies werden auf Ihrer Endeinrichtung gespeichert, sodass Sie die Kontrolle über Cookies haben. Wenn Sie nicht möchten, dass wir Ihre Endeinrichtung wiedererkennen, können Sie jederzeit bereits auf Ihrer Endeinrichtung gespeicherte Cookies – manuell oder automatisiert – deaktivieren bzw. löschen und/oder die Speicherung von Cookies für die Zukunft blockieren, indem Sie in Ihrer Webbrowser-Software die entsprechende Einstellung vornehmen, z.B. „keine Cookies akzeptieren“ oder Ähnliches. Die meisten Webbrowser können zudem so konfiguriert werden, dass eine Speicherung von Cookies nur akzeptiert wird, wenn Sie dem gesondert im Einzelfall zustimmen. Wenn Sie die Cookies unserer Dienstleister und Partner nicht akzeptieren wollen, sollten Sie hierzu in Ihrem Webbrowser die Einstellung „Cookies von Drittanbietern blockieren“ oder Ähnliches vorfinden. In der Regel wird Ihnen in der Menüleiste Ihres Webbrowsers über die Hilfe-Funktion angezeigt, wie Sie bereits gespeicherte Cookies ausschalten bzw. löschen und neue Cookies abweisen können. Einzelheiten zu den beschriebenen Möglichkeiten entnehmen Sie bitte der Anleitung Ihres Webbrowser-Herstellers.",
                    describtionTwo:
                      "Bitte beachten Sie, dass bei einem Löschen ohne ein Blockieren erforderliche Cookies neu eingesetzt werden und wir Sie bezüglich optionaler Cookies gegebenenfalls erneut um Ihre Einwilligung bitten, wenn Sie unsere Website zu einem späteren Zeitpunkt wieder aufrufen. Beachten Sie ferner, dass eine Deaktivierung bzw. Löschung oder Blockierung erforderlicher Cookies die Leistung und Funktionalität unserer Website beeinträchtigen und bewirken kann, dass bestimmte Funktionen und Merkmale nicht zur Verfügung stehen.",
                    describtionThree:
                      "Sie können die Einstellungen zum Einsatz optionaler Cookies und der damit verbundenen Datenverarbeitung jederzeit in den <a>Einstellungen</a> des Einwilligungsverwaltungsdienstes verwalten.",
                  },
                  sectionThriteen: {
                    title: "Datenempfänger",
                    describtion:
                      "Wir übermitteln Ihre Daten gegebenenfalls an:",
                    dashOne:
                      "Andere Unternehmen der Liebherr-Gruppe, sofern dies zur Anbahnung, Durchführung oder Beendigung eines Vertrages erforderlich ist oder auf unserer Seite ein berechtigtes Interesse an der Übermittlung besteht und Ihr überwiegendes berechtigtes Interesse dem nicht gegenübersteht;",
                    dashTwo:
                      "Die Anbieter der von Ihnen aktiv in Anspruch genommenen Funktionen und eventueller sonstiger Dienste oder Dienstleistungen;",
                    dashThree:
                      "Unsere Dienstleister, die wir zur Erreichung der oben genannten Zwecke einsetzen;",
                    dashFour: "Den oder die von Ihnen gewünschten Empfänger;",
                    dashFive:
                      "Gerichte, Schiedsgerichte, Behörden oder Rechtsberater, wenn dies zur Einhaltung geltenden Rechts oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist.",
                  },
                  sectionFourteen: {
                    title: "Datenübermittlungen in Drittländer",
                    describtionOne:
                      "Eine Datenübermittlung an Stellen in Staaten außerhalb der Europäischen Union bzw. des Europäischen Wirtschaftsraums (sogenannte Drittländer) oder an internationale Organisationen ist nur zulässig, (1) soweit Sie uns Ihre Einwilligung erteilt haben oder (2) sofern die Europäische Kommission entschieden hat, dass in einem Drittland ein angemessenes Schutzniveau besteht (Art. 45 DSGVO). Hat die Kommission keine solche Entscheidung getroffen, dürfen wir Ihre Daten an Empfänger, die sich in einem Drittland befinden, nur übermitteln, sofern geeignete Garantien vorhanden sind (z.B. Standarddatenschutzklauseln, die von der Kommission oder der Aufsichtsbehörde nach einem bestimmten Verfahren angenommen werden) und die Durchsetzung Ihrer Betroffenenrechte sichergestellt wird bzw. die Übermittlung im Einzelfall aufgrund sonstiger Erlaubnistatbestände zulässig ist (Art. 49 DSGVO).",
                    describtionTwo:
                      "Sofern wir Ihre Daten in Drittländer übermitteln, unterrichten wir Sie über die jeweiligen Einzelheiten der Übermittlung an den dafür relevanten Stellen in dieser Datenschutzerklärung.",
                  },
                  sectionFiveteen: {
                    title: "Datenlöschung und Speicherdauer",
                    describtionOne:
                      "Wir verarbeiten Ihre Daten, solange dies für den jeweiligen Zweck erforderlich ist, sofern Sie nicht wirksam der Verarbeitung Ihrer Daten widersprochen oder Ihre etwaige Einwilligung wirksam widerrufen haben.",
                    describtionTwo:
                      "Soweit gesetzliche Aufbewahrungspflichten bestehen, werden wir die davon betroffenen Daten für die Dauer der Aufbewahrungspflicht speichern müssen. Nach Ablauf der Aufbewahrungspflicht prüfen wir, ob eine weitere Erforderlichkeit für die Verarbeitung vorliegt. Liegt eine Erforderlichkeit nicht mehr vor, werden Ihre Daten gelöscht.",
                  },
                  sectionSixteen: {
                    title: "Datensicherheit",
                    describtion:
                      "Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um zu gewährleisten, dass Ihre Daten vor Verlust, unrichtigen Veränderungen oder unberechtigten Zugriffen Dritter geschützt sind. In jedem Fall haben von unserer Seite überdies nur berechtigte Personen Zugang zu Ihren Daten, und dies auch nur insoweit, als es im Rahmen der oben genannten Zwecke erforderlich ist. Die Übertragung aller Daten erfolgt verschlüsselt.",
                  },
                },
              },
            },
          },
          // Infotexts
          infotexts: {
            general: {
              key: {
                title: "Produktschlüssel",
                text: `Der Produktschlüssel ist die eindeutige Zeichenfolge einer Konfiguration und kann zur Speicherung sowie zum Wiederaufrufen der Konfiguration verwendet werden.`,
                linkTitle: "Anleitung herunterladen",
              },
              comparison: {
                title: "Meine Konfigurationen",
                text: "Wenn Sie die Konfiguration speichern, finden Sie ihr Projekt unter dem Bereich 'Meine Konfigurationen'. Sie können selbstverständlich mehrere Konfigurationen speichern und diese auch untereinander vergleichen.",
              },
              downloads: {
                title: "Formate herunterladen",
                text: "Nach Anmeldung haben Sie die Möglichkeit verschiedene 3D-Bildformate oder CAD-Bildformate herunterzuladen oder ein Datenblatt zu erstellen.",
              },
            },
            series260: {
              CT: {
                text: `Abhängig von der gewählten Anbindungsart sind unterschiedliche Einbau- und Hublängen möglich. Bitte beachten Sie, dass bei der Auswahl „fest gelagert“ kein vormontierter Gelenkkopf konfigurierbar ist.`,
              },
              SD: {
                text: `Kolbenstangenbeschichtung Doppelchrom nur von Stangen-Ø 70 bis einschließlich Ø 125 verfügbar (Andere Beschichtungsarten auf Anfrage möglich)`,
              },
              EL: {
                text: `Die Einbaulänge definiert die Länge zwischen den beiden Anbindungspunkten. Ein Kolbenstangenüberstand ist innerhalb der konfigurierbaren Hub- und Einbaulängen möglich.`,
              },
              HUB: {
                text: `Der Hub ist im eingefahrenen Zustand dargestellt.
                Ein Ausfahren der Kolbenstange ist im Feld "Dargestellter Hub" im 3D Modell möglich. 
                \nNicht konfigurierbare Hublängen sind auf Anfrage möglich.`,
              },
              POS: {
                text: `Zeigt den individuell dargestellten Verfahrweg des Hubes an. Diese Möglichkeit funktioniert auch nachträglich im CAD-Modell.`,
              },
              MAT: {
                text: `Im Standard wird eine hochwertige Einfachchromschicht mit einer Dicke von 25 μm (±5 μm) verwendet. Für höhere Korrosions- oder Schlagschutzanforderungen steht eine gehärtete Kolbenstange mit einer Doppelchrombeschichtung zur Verfügung. Diese Beschichtung gewährleistet mindestens 96 h in der Essigsäure-Salzsprühnebelprüfung (AASS) nach DIN EN ISO 9227 Rating 10.`,
              },
              V: {
                text: `Um eventuell auftretende Schäden am Hydraulikzylinder zu vermeiden empfehlen wir diesen vor der ersten Inbetriebnahme zu entlüften.
                (Anschlussgewinde G 1/4)`,
              },
              COL: {
                text: `Neben einer Grundierung kann der Zylinder in Liebherr-Grau lackiert werden.`,
              },
            },
            series380: {
              EL: {
                text: `Die Einbaulänge definiert die Länge zwischen den beiden Anbindungspunkten. Ein Kolbenstangenüberstand ist innerhalb der konfigurierbaren Hub- und Einbaulängen möglich. Nicht konfigurierbare Einbaulängen sind auf Anfrage möglich.`,
              },
              HUB: {
                text: `Der Hub ist im eingefahrenen Zustand dargestellt.
                Ein Ausfahren der Kolbenstange ist im Feld "Dargestellter Hub" im 3D Modell möglich. 
                \nNicht konfigurierbare Hublängen sind auf Anfrage möglich. `,
              },
              POS: {
                text: `Zeigt den individuell dargestellten Verfahrweg des Hubes an. Diese Möglichkeit funktioniert auch nachträglich im CAD-Modell.`,
              },
              MAT: {
                text: `Im Standard werden hochwertige Chrom- und Nickel-Chrom-Beschichtungen verwendet. Je nach Anwendungsfall kommt eine Beschichtung mit normaler Beständigkeit (AASS Essigsäure-Salzsprühnebelprüfung nach DIN EN ISO 9227 mit 96 h) oder eine mit erhöhter Beständigkeit (AASS mit 240 h) zum Einsatz. Ebenso kann eine Seewasser-Beschichtung (AASS mit 500 h) geliefert werden. Bemessungsgrundlage für alle Beschichtungen ist Rating 10 nach DIN EN ISO 10289.`,
              },
              DAM: {
                text: `Gerade bei hochdynamischen Bewegungen kommt es oft auf ein kontrolliertes und sanftes Einfahren in die Endlagen an. Optional kann zwischen einer bodenseitigen und/oder stangenseitigen, fest eingestellten Dämpfung ausgewählt werden. Die Einstellung der Dämpfung muss dabei für jeden Anwendungsfall individuell geprüft werden. Das System gewährleistet so ein ruckel- und verzögerungsfreies Anfahren.`,
              },
              SAE: {
                text: `Die Position des stangenseitigen Ölanschlusses kann individuell gewählt werden. 
                \nSAE-Anschluss nach ISO 6162 (6000 PSI).`,
              },
              COL: {
                text: `Neben einer Grundierung kann der Zylinder in Liebherr-Grau oder in einer individuellen Farbe (nach RAL) lackiert werden. Wird lediglich die Grundierung gewählt, ist keine maritime Lackierung erhältlich.`,
              },
              TCOL: {
                text: `Die maritime Lackierung bietet einen besondernen Korrossionsschutz, speziell für Anwendungen rund um einen Einsatz im Seewasserumfeld.`,
              },
              OPT: {
                text: `Um eine verbesserte Oberflächenqualität des Zylinderrohres zu erzielen, wird eine mechanische Oberflächenbearbeitung empfohlen.`,
              },
              RCOL: {
                text: `Bitte beachten Sie, dass bei Auswahl eines individuellen RAL-Tons das 3D Modell nicht in der richtigen Farbe dargestellt wird. Im Produktschlüssel sowie auf dem Datenblatt ist der gewählte Ton jedoch ersichtlich.`,
              },
              DE: {
                text: "Optional sind unsere Lösungen der Serienbaureihe 380 bar auch als gewichtsoptimierte Variante mit einer CFK-Umwicklung verfügbar. Somit sind bis zu 13% Gewichtseinsparung möglich. Aufgrund vereinfachter Knickberechnung sind die konfigurierbaren Längen teilweise geringer als im Standard.",
                linkDesc:
                  "Weitere Informationen zu diesem Werkstoff finden Sie unter…",
                linkTitle: "Liebherr Hybridzylinder | Liebherr",
                url: "https://www.liebherr.com/de/deu/produkte/komponenten/hydraulik/hybridzylinder/hybridzylinder.html",
              },
            },
            iso6022: {
              MT: {
                text: `Das Wegmesssystem Temposonics R-Series V RH5 ist für die Befestigungsarten MP3&MP5 nicht verfügbar.`,
              },
              CT: {
                text: `Abhängig von der gewählten Anbindungsart sind unterschiedliche Einbau- und Hublängen möglich. Bitte beachten Sie, dass bei der Auswahl „fest gelagert“ kein vormontierter Gelenkkopf konfigurierbar ist.`,
              },
              SD: {
                text: `Kolbenstangenbeschichtung Doppelchrom nur von Stangen-Ø 70 bis einschließlich Ø 125 verfügbar (Andere Beschichtungsarten auf Anfrage möglich)`,
              },
              EL: {
                text: `Die Einbaulänge definiert die Länge zwischen den beiden Anbindungspunkten. Ein Kolbenstangenüberstand ist innerhalb der konfigurierbaren Hub- und Einbaulängen möglich.`,
              },
              HUB: {
                text: `Der Hub ist im eingefahrenen Zustand dargestellt. Ein Ausfahren der Kolbenstange ist im Feld "Dargestellter Hub" im 3D Modell möglich.
                \nNicht konfigurierbare Hublängen sind auf Anfrage möglich.
                \nDas Wegmesssystem ist bis zu einer Hublänge von maximal 2.400mm auswählbar`,
              },
              POS: {
                text: `Zeigt den individuell dargestellten Verfahrweg des Hubes an. Diese Möglichkeit funktioniert auch nachträglich im CAD-Modell.`,
              },
              PRV: {
                text: `Im Standard wird eine hochwertige Einfachchromschicht mit einer Dicke von 25 μm (±5 μm) verwendet. 
                Für höhere Korrosions- oder Schlagschutzanforderungen steht eine gehärtete Kolbenstange mit einer Doppelchrombeschichtung zur Verfügung. Diese Beschichtung gewährleistet mindestens 96 h in der Essigsäure-Salzsprühnebelprüfung (AASS) nach DIN EN ISO 9227 Rating 10.`,
              },
              CBA: {
                text: `Um einen Steuerblock auf der Stangen- und Bodenseite am Ölanschluss anbringen zu können, können alle Hydraulikzylinder der Serienbaureihe hierfür vorgesehen werden. 
                \nHierzu wird die relevante Fläche am jeweiligen Befestigungsring entsprechend der obenstehenden Abbildung plangefräst.`,
              },
              DAM: {
                text: `Gerade bei hochdynamischen Bewegungen kommt es oft auf ein kontrolliertes und sanftes Einfahren in die Endlagen an. Optional kann zwischen einer bodenseitigen und/oder stangenseitigen, einstellbaren Dämpfung ausgewählt werden.`,
              },
              POSMS: {
                text: `Um den Verfahrweg des Hydraulikzylinders kontinuierlich zu erfassen und ggf. zu regeln ist der Einsatz eines Wegmesssystems notwendig. Das magnetostriktives Positionsmesssystem wird mit einem Gerätestecker (6pol.) und Analogausgang 20…4mA geliefert (Alternative Ausgänge auf Anfrage) Sobald ein Wegmesssystem ausgewählt ist, kann kein Näherungsschalter ausgewählt werden.`,
              },
              PS: {
                text: `Zur Erfassung der Endlagen eines Hydraulikzylinders kann ein induktiver Näherrungsschalter eingesetzt werden. Diese Option entfällt bei vorheriger Auswahl eines Wegmesssystems. Näherungsschalter mit M12x1 Gewinde; Elektrische Ausführung PNP - Schließfunktion; IP65,68,69; Spannung 10...36V.`,
              },
              V: {
                text: `Um eventuell auftretende Schäden am Hydraulikzylinder zu vermeiden empfehlen wir diesen vor der ersten Inbetriebnahme zu entlüften. (Anschlussgewinde G 1/4)`,
              },
              COL: {
                text: `Neben einer Grundierung kann der Zylinder in Liebherr-Grau lackiert werden.`,
              },
            },
          },
        },
      },
    },
  });

// Set default lang attribute
document.documentElement.setAttribute(
  "lang",
  i18next.language === "de-DE" || i18next.language === "de" ? "de" : "en"
);

// Set lang attribute on language change
i18next.on("languageChanged", (lng) => {
  document.documentElement.setAttribute("lang", lng);
});
